import { ERROR_KEYS } from '@lemontaps/lib/constants';

export const en = {
  translation: {
    text: 'Text',
    academy: 'Academy',
    phoneNumberRenderedAs: 'Rendered as: {{nr}}',
    none: 'None',
    generating: 'Generating...',
    filling: 'Filling in the form...',
    nFiltersApplied_one: '{{count}} filter applied',
    nFiltersApplied_other: '{{count}} filters applied',
    checked: 'Checked',
    unchecked: 'Unchecked',
    both: 'Both',
    manage: 'Manage',
    copied: 'Copied',
    copiedToClipboard: 'Copied to clipboard',
    ariaCopy: 'Copy {{label}}',
    copy: 'Copy',
    paste: 'Paste',
    setup: 'Setup',
    updated: 'Updated',
    deleted: 'Deleted',
    disabled: 'Disabled',
    requiresApproval: 'Requires approval',
    requests: 'Requests',
    requestApproval: 'Request Approval',
    requestDeleteApproval: 'Request Delete',
    newUser: 'New User',
    new: 'New',
    changeRequested: 'Change requested',
    AI: 'AI',
    leadCollectedVia: 'Unit',
    collectedViaGlobalForm: 'Global Form',
    showAll: 'Show all',
    changeRole: 'Change Role',
    addField: 'Add field',
    selectUser: 'Select User',
    paperBusinessCard: 'Paper business card',
    imageSizeInfo: {
      coverImage: 'Aspect ratio: 16:9. Recommended resolution: 1920x1080px.',
      logoImage: 'Any image format. Recommended minimum resolution for the smaller side: 300px.',
      profileImage:
        'Aspect ratio: 1:1. Cropped as a circle. Recommended minimum resolution per side: 600px.',
      faviconImage: 'Aspect ratio: 1:1. Recommended resolution: 16x16px.',
    },
    fallback: 'Fallback',
    quotaExceeded: 'Quota exceeded. Contact sales or wait until the quota resets.',
    paperCards: 'Paper business cards',
    profilePicture: 'Profile Picture',
    colSortMenu: {
      dialogTitle: 'Customize table columns',
      description: 'Here you can change the order of the table columns or hide columns entirely.',
      showColumnHeader: 'Show column',
    },
    fonts: 'Font',
    selectFont: 'Select Font',
    resetPassword: 'Reset Password',
    control: {
      title: 'Control',
      scim: 'SCIM',
      scimHelper: 'This field is controlled by SCIM. Your changes may be overridden.',
      entraIdSync: 'Entra-ID-Sync',
      entraIdSyncHelper:
        'This field is controlled by Entra-ID-Sync. Your changes may be overridden.',
      manual: 'Manual',
      defaultContentHelper:
        'This value is a default value and can only be changed in the profile design settings.',
    },
    ariaProfileFile: 'Profile file',
    ariaProfileLink: 'Profile link',
    ariaSelectStartDay: 'Select {{date}} as start of the date range',
    ariaSelectEndDay: 'Select {{date}} as end of the date range',
    ariaSelectMonth: 'Select month',
    ariaSelectYear: 'Select year',
    ariaMoveMonthBack: 'Navigate back by one month',
    ariaMoveMonthForward: 'Navigate forward by one month',
    ariaFrom: 'From',
    ariaTo: 'To',
    ariaHeaderDateRangePicker: 'Date Range Selector',
    ariaSelectPredefinedRange: 'Select pre-defined date range: ',
    ariaHelpTooltip: 'Help',
    ariaInfoTooltip: 'Info',
    ariaGdprConsent: 'Toggle GDPR consent',
    ariaAddProfilePicture: 'Add a profile picture',
    ariaEditProfilePicture: 'Edit profile picture',
    ariaEditContactDetails: 'Edit contact details',
    ariaGoBack: 'Go back',
    ariaShowAllSharingOptions: 'Show all options for sharing your profile',
    ariaAcademySwiperPreviousVideo: 'Previous academy video',
    ariaAcademySwiperNextVideo: 'Next academy video',
    ariaNavHeaderProfile: 'Toggle single user profile pages navigation',
    ariaNavHeaderAdmin: 'Toggle admin pages sub-navigation',
    ariaNavHeaderTeamSettings: 'Toggle team settings sub-navigation',
    ariaNavHeaderSettings: 'Toggle settings sub-navigation',
    ariaHeaderAdminDropdown: 'Open account settings menu',
    ariaHeaderHelpDropdown: 'Open help menu',
    ariaAddLink: 'Add link',
    ariaAddFile: 'Add file',
    onlyPreview: 'This is only a preview',
    ariaCollapseTo_one: 'Collapse this list to one item',
    ariaCollapseTo_other: 'Collapse this list to {{count}} items',
    ariaExpandFor_one: 'Expand contact details to reveal one more item',
    ariaExpandFor_other: 'Expand contact details to reveal {{count}} more items',
    ariaOpenCookieSettings: 'Open cookie settings',
    adminDisabledEditRight: 'Your administrator has disallowed editing here.',
    ariaDigitalBusinesscardOf: 'Digital Business Card of',
    ariaLogoImage: 'Company Logo',
    ariaProfilePicture: 'Profile picture',
    ariaOpenToEnlarge: 'You can open the image in a modal',
    ariaBannerImageOption: 'Image option {{n}} for the profile banner',
    ariaBannerImageOptionsLabel: 'Choose an image from the options as a profile banner.',
    addAnotherUser: 'Add another user',
    livePreview: 'Live Preview',
    sendViaEmail: 'Send via Email',
    ariaLogoOf: 'Logo of {{name}}',
    teamSettingsSubmenu: 'Team settings - opens team settings submenu',
    settingsSubmenu: 'Settings - opens settings submenu',
    default: 'Default',
    template: 'Template',
    embed: 'Embed',
    bulkEdit: 'Edit',
    bulkEditProfiles: 'Bulk Edit',
    back: 'Back',
    disconnect: 'Disconnect',
    done: 'Done',
    internalContactPerson: 'Internal Contact Person',
    generalDesign: 'General Design',
    defaultContent: 'Default Content',
    contentTemplate: 'Content Templates',
    editBio: 'Edit Bio',
    fileupload: 'File upload',
    value: 'Value',
    selectField: 'Select Field',
    override: 'Override',
    card: 'NFC-Card',
    addFileDialog: {
      title: 'Title',
      videoUrl: 'Video-Link',
      modeFile: 'File Upload',
      modeVideoLink: 'Video Embed',
      embedVideo: {
        label: 'Embed Video',
        tooltip: 'By embedding the video, it can be directly viewed from within the profile.',
        placeholder: 'Paste the video URL (from Youtube, Vimeo, etc.)',
      },
      embedVideoAlert: {
        title: 'Embed a video',
        content: 'You can embed a video directly from different sources (YouTube, Vimeo, etc.).',
        helpReference: 'See <0>this page</0> for more information.',
      },
      error: {
        invalidEmbedUrl: 'Not a valid video link',
      },
    },
    upgradeNow: 'Upgrade now',
    contactSales: 'Contact Sales',
    testBusinessSolution: 'Business Solution',
    select: 'Select',
    standard: 'Standard',
    fillRequired: 'Fill out the required fields',
    navSidebar: {
      ariaGoHome: 'Go to the home page',
      settings: 'Settings',
      teamSettings: {
        ariaGoBack: 'Back to the main navigation menu',
      },
      collapseButton: {
        aria: {
          label: 'Collapse/Extend Sidebar',
        },
      },
    },
    approve: 'Approve',
    reject: 'Reject',
    changeRequests: {
      featureTeaser: 'Upgrade to enable this feature',
      title: 'Change Requests',
      requestSuccess: 'Request successfully sent',
      requestError: 'Error sending change requests',
      approveSuccess: 'Changes successfully approved',
      approveError: 'Error approving change requests',
      rejectSuccess: 'Changes successfully denied',
      rejectError: 'Error rejecting change requests',
      noChangeRequestsTitle: 'No change requests',
      noChangeRequestsDescription:
        'Change requests for restricted fields will appear here. You can set field restrictions within the edit rights settings.',
      manageChangeRequests: 'Manage change requests',
      description:
        'Your team has submitted requests to make changes. Approve or deny changes below.',
      approveConfirmDialog: {
        title: 'Approve change requests',
        description: 'Are you sure you want to approve these change requests?',
      },
      rejectConfirmDialog: {
        title: 'Are you sure to reject the changes?',
        reason: 'Optional: Enter a reason',
        reasonHelper: 'The reason will be mentioned in the notification email.',
      },
      manageEmailRecipients: 'Manage Email Recipients',
    },
    profileSettings: 'Profile Settings',
    addCover: 'Add Cover Image',
    addLogo: 'Add Logo',
    addImage: 'Add Image',
    addAvatar: 'Add Profile Image',
    addFavicon: 'Add Favicon',
    add: 'Add',
    note: 'Note',
    at: 'at',
    preferredLang: 'Language',
    admin: 'Admin',
    nonAdmin: 'End user',
    controlVisibility: 'Control Visibility',
    scanCard: 'Scan Card',
    scanCardShort: 'Scan',
    search: 'Search',
    noSearchOptions: 'No search options',
    customizeTable: 'Customize Table',
    upgradeToContinue: 'For this action you need to upgrade first',
    deselectAll: 'Deselect All',
    selectAll: 'Select All',
    namePrefix: 'Name Prefix',
    salutation: 'Salutation',
    namePrefixHelper: 'e.g. Dr., Prof.',
    nameSuffix: 'Name Suffix',
    nameSuffixConnector: {
      space: 'Space',
      comma: 'Comma',
      colon: 'Colon',
      newline: 'Line Break',
    },
    academicDegree: 'Academic Degree',
    academicDegreeHelper: 'e.g. Ing., B.Sc.',
    academicDegree2: 'Academic Degree 2',
    academicDegree2Helper: 'Line 2',
    toPaperCardOrderForm: 'To the paper business card order form',
    close: 'Close',
    help: 'Help',
    gdpr: 'GDPR',
    upstreamLeadObjectType: 'Contact/Lead',
    upstreamLeadObjectTypeLead: 'Lead',
    upstreamLeadObjectTypeContact: 'Contact',
    upstreamLeadObjectTypeNotSpecified: 'Not specified',
    gdprLegalBasis: 'GDPR',
    addressee: 'Addressee',
    addressLine1: 'Address Line 1',
    addressLine2: 'Address Line 2',
    postCode: 'Postcode',
    city: 'City',
    country: 'Country',
    address: {
      addressee: 'Addressee',
      addressLine1: 'Address Line 1',
      addressLine2: 'Address Line 2',
      postCode: 'Postcode',
      city: 'City',
      country: 'Country',
      label: 'Address Label',
      2: {
        addressee: '2. Addressee',
        addressLine1: '2. Address Line 1',
        addressLine2: '2. Address Line 2',
        postCode: '2. Postcode',
        city: '2. City',
        country: '2. Country',
        label: '2. Address Label',
      },
    },
    address1: 'Address 1',
    address2: 'Address 2',
    editDisabledTooltip:
      "The admin has restricted this function. You can find you admin's contact information in the help button at the top right.",
    editDisabledTooltipWithEmail: 'Only an admin can edit this. Please contact {{email}}.',
    scanner: 'Scanner',
    stillMultiAssigned: 'Some accounts are still assigned to more than one unit',
    editNotAllowed: 'Your administrator has not allowed editing this setting for your unit.',
    onlyExt: 'Only ',
    unsavedChangesText: 'You may have unsaved changes. Continue?',
    featureNotAllowed: 'Upgrade to enable this feature',
    upgrade: 'Upgrade',
    openLinkInNewTab: 'Open Link in new Tab',
    needHelp: 'Need help?',
    confirm: 'Confirm',
    finish: 'Finish',
    apply: 'Apply',
    duplicate: 'Duplicate',
    deleteSettings: 'Delete Unit Settings',
    settingDeleteConfirmation:
      'Do you really want to delete the unit settings? The settings will then be synchronized again with the global organization settings.',
    settingDeleteConfirmationTitle: 'Delete Unit Settings',
    resetSettings: 'Reset',
    settingResetConfirmation:
      'Do you really want to completely reset the settings to their initial state? All unit settings will also be deleted.',
    settingResetConfirmationTitle: 'Reset to Initial Settings',
    setupSettings: {
      title: "Currently this unit's settings are in sync with the organization settings.",
      description:
        "You can set special settings for this unit, but they won't be in sync with the organization settings anymore.",
      buttonText: 'Set up unit settings +',
    },
    upgradedOnMobile: {
      title: 'Welcome to Lemontaps Teams 🎉',
      text: 'To guarantee you a good and safe user experience, it is only possible to use the admin management view and functionalities on the desktop. Therefore, log in on the desktop right away to access the new features.',
    },
    wallet: {
      description:
        'Add Lemontaps to your {{company}} Wallet and share your contact using the QR code in the wallet.',
      step1: 'Select the QR code type',
      step2: 'Download your business card into your wallet',
      hint: {
        title: 'Add to {{device}} device wallet directly?',
        p1: 'First, scan the following QR-Code to log into Lemontaps on your {{device}} device',
        p2: 'Then, go to "Share profile" -> "Wallet" and click on the "Add to {{company}} Wallet" button on your {{device}} device.',
        browsers:
          '⚠️ The wallet functionality may not be working correctly in your browser. Use Safari or Chrome instead for generating the business card for your wallet.',
      },
    },
    sendFollowUpEmailPopup: {
      title: 'Follow-Up E-Mail',
      body: 'Do you want to send the follow-up e-mail to {{leadEmail}} now?',
    },
    toProfile: 'To my profile',
    profileOf: 'Profile of {{name}}',
    contactUs: 'Contact us',
    openOnDesktop:
      'Access to the Admin Management Platform is only possible via desktop devices, due to security measures.',
    upgradeRequestPopup: {
      title: 'Contact us to upgrade',
    },
    upgradePopup: {
      title: 'Welcome to Lemontaps {{plan}} 🎉',
      q1: 'What is the name of your organization?',
      q2: 'How many potential users are there?',
      submit: 'Start now!',
    },
    myCards: 'NFC-Cards',
    profileOverview: 'Profile Overview',
    profileOverviewFromUnits: 'Unit Members',
    header: {
      help: 'Help',
      helpCenter: 'Help Center',
      chatWithUs: 'Chat with us',
      bookCall: 'Book 10 min Call',
      support: 'Support',
      settings: 'Account Settings',
      teamManagement: 'Team Management',
      langSelector: {
        aria: {
          label: 'Change language',
          en: 'English Language',
          de: 'Deutsch Language',
        },
      },
    },
    saved: 'Saved',
    permissionLevel: 'Permission Level',
    ue: 'Unexpected Error',
    unexpectedError: 'Unexpected Error',
    invalidCharEntered: 'Invalid symbol',
    explainTemplatedLink: 'This is a standard link. It can be removed, but not edited.',
    explainThemeLink: 'This link was set up by an admin and cannot be edited',
    explainThemeLinkToAdmin:
      'This link is shown on every profile. It can be edited via the profile design page.',
    explainThemeFile: 'This file was set up by an admin and cannot be edited',
    explainThemeFileToAdmin:
      'This file is shown on every profile. It can be edited via the profile design page.',
    username: 'Username',
    uploading: 'Uploading',
    mobileBg: 'Smartphone Background',
    videoBg: 'Video Background',
    minute_one: '{{count}} minute',
    minute_other: '{{count}} minutes',
    addData: 'Add data',
    notEnoughLicences: 'You do not have enough licences',
    startNow: 'Start now',
    resetToDefault: 'Reset to default',
    editColumns: 'Edit columns',
    role: 'Role',
    accountDetails: 'Account Details',
    title: 'Title',
    Loading: 'Loading',
    LoadingLong: 'This might take some time',
    deleting: 'Deleting',
    saving: 'Saving',
    you: 'You',
    Dismiss: 'Dismiss',
    tryForFree: 'Try for free',
    edit: 'Edit Details',
    myLinks: 'My Links',
    addLink: 'Add a link',
    editLinks: 'Edit links',
    addAddress: 'Add an address',
    editAddress: 'Edit address',
    addFile: 'Add a file',
    editFile: 'Edit file',
    assign: 'Assign',
    unitAssign: 'Assign unit',
    unassign: 'Unassign',
    files: 'Files',
    links: 'Links',
    contactsForm: 'Contacts Form',
    additionalCover: 'Additional Cover Images',
    showContactsForm: 'Show form',
    showContactsFormAsPopup: 'Show as popup',
    website: 'Website',
    linkedInLink: 'LinkedIn-URL',
    numberOfEmployees: 'Number of employees',
    pasteToWebsite: 'Now go paste the data to your post',
    addProfile: 'Add User',
    chooseLink: 'Choose a link type',
    useTemplate: 'Use Template',
    createNewTemplate: 'Create New Template',
    selectTemplate: 'Select template',
    createOwnLink: 'Create own link',
    shareVia: 'Share with {{app}}',
    copyText: 'Copy Text',
    openLink: 'Open page',
    chooseLinks: 'Choose links',
    myFiles: 'My Files',
    showProfile: 'Show Profile',
    myProfile: 'My Profile',
    coverPicture: 'Cover Picture',
    editCoverPicture: 'Edit Cover Picture',
    editLogo: 'Edit Logo',
    chooseCoverPicture: 'Choose Cover Image',
    chooseLogoPicture: 'Choose logo',
    editHeaderLogo: 'Logo',
    editLogoTooltip:
      'Here you can upload a specific company logo to each individual employee or to a group, e.g. if there are different brands. However, this logo will be overwritten uniformly for all if a logo is set in the global setting.',
    errorUploadingImage: 'Error uploading image',
    errorUpdatingImage: 'Error updating image',
    updatingImage: 'Updating image',
    uploadingImage: 'Uploading image',
    nameLink: 'Name your link',
    enterUsername: 'Enter your username',
    enterPhone: 'Enter your phone number',
    save: 'Save',
    enrich: 'Enrich',
    cancel: 'Cancel',
    record: 'Record',
    delete: 'Delete',
    enterLink: 'Enter your link',
    createLink: 'Create a link',
    editLink: 'Edit the link',
    redirectMessage:
      'Redirect your business card directly to this link. Your digital business card is currently accessible.',
    redirectOffMessage:
      'Show your digital business card again when you share your profile. Currently, it is automatically redirected to this link.',
    hideMessageLink: 'Hide this link from your profile. It is currently displayed.',
    showMessageLink: 'Display this link on your profile again. It is currently hidden.',
    hideMessageFile: 'Hide this file from your profile. It is currently displayed.',
    showMessageFile: 'Display this file on your profile again. It is currently hidden.',
    nameFile: 'Name your file',
    upload: 'Upload',
    uploadNew: 'Upload new',
    browseFiles: 'Browse Files',
    deleteLink: 'Delete link',
    saveContact: 'Save contact',
    editProfile: 'Edit Profile',
    editProfiles: 'Edit profiles',
    myContactDetails: 'My Contact Details',
    contactDetails: 'Contact Details',
    submitYourContact: 'Submit your contact information and\nreceive mine by email:',
    account: 'Account',
    connectAccount: 'Connect Account to a Tap or Card',
    sendContactProfile: 'Send me your contact and\nreceive mine by email:',
    myContacts: 'My Contacts',
    addContact: 'Add new Contact',
    addContactShort: 'Contact',
    howToTap: 'How to tap a phone?',
    tapIphone: 'How To Tap Iphone',
    tapAndroid: 'How To Tap an Android',
    howtotap: 'How To Tap',
    showNow: 'Shop now',
    changePassword: 'Change Password',
    logout: 'Logout',
    nfcInfo1: '1. NFC has to be activated',
    nfcInfo2: "iPhone XR and newer: It's already automatically activated.",
    nfcInfo3:
      'iPhone 7 - Iphone X:iOS14 needs to be installed. Go to "settings" - "Control Center" and add "NFC".',
    nfcInfo4: 'Now swipe the control center and press the NFC sign to tap:',
    nfcInfo5: "Phone still doesn't have NFC?",
    nfcInfo6: '2. Tap',
    nfcInfo7: "Tap it against the upper part of someone's iPhone",
    nfcInfo8: 'Activate "NFC" once in the menu from the top.',
    nfcInfo9: "If it's not already in the menu you need to first turn it on in the settings:",
    nfcInfo10: 'Settings - Connections - NFC and Payments',
    nfcInfo11: 'Settings - Device Connections - NFC',
    nfcInfo12: 'Settings - Connected devices - Connection Setting - NFC',
    nfcInfo13: 'Settings - More - Mobile Data - NFC',
    nfcInfo14: 'Link your Lemontap or Lemoncard to your profile',
    nfcInfo15: 'You can find the code on the packaging underneath your product.',
    nfcInfo16:
      'You can always buy a Lemontap or a Lemoncard later and connect it to your profile in the menu.',
    nfcInfo17: 'Tap it against the middle part of the back of someone’s Android phone',
    gotIt: 'Got it',
    accountRole: 'Permission',
    firstName: 'First Name',
    lastName: 'Last Name',
    birthday: 'Birthday',
    position: 'Position',
    company: 'Company',
    costCenter: 'Cost Center',
    internalNotes: 'Internal Notes',
    division: 'Division',
    businessCardUrl: 'Business Card',
    businessCardUrls: 'Business Cards',
    profileImageUrl: 'Profile Image',
    mobilePhone: { text: 'Telephone - Mobile', label: 'Mobile' },
    workPhone: { text: 'Telephone - Work', label: 'Work' },
    homePhone: { text: 'Telephone - Home', label: 'Home' },
    hotlinePhone: { text: 'Hotline', label: 'Hotline' },
    assistantPhone: { text: 'Telephone - Assistance', label: 'Assistance' },
    phone: 'Phone',
    assistantEmail: { text: 'Assistance Email', label: 'Assistenz' },
    assistantName: { text: 'Assistance Name', label: 'Assistenz' },
    assistantGeneric: { text: 'Assistance Misc', label: 'Assistenz' },
    workFax: { text: 'Fax', label: 'Fax' },
    authEmail: 'Account-Email',
    createdOn: 'Created On',
    editedAt: 'Edited On',
    email1: 'Email 1',
    email2: 'Email 2',
    email3: 'Email 3',
    workUrl: 'Homepage URL',
    bioText: 'Bio (free text)',
    update: 'Update',
    allProfilesMD: 'All Profiles',
    rowsPerPage: 'Rows Per Page:',
    of: 'of',
    searchMD: 'Search for...',
    emptySearchMD: {
      tooltip: 'Enter "#empty#" to filter for empty values or click here',
      tag: '#empty#',
    },
    editMD: 'Edit',
    editSelected: 'Edit Selected',
    editSelected_one: 'Edit Profile',
    editSelected_other: 'Edit {{count}} profiles',
    deleteSelected: 'Delete Selected',
    deleteSelected_one: 'Delete Profile',
    deleteSelected_other: 'Delete {{count}} Profiles',
    deleteBulkMessageConfirmation_one:
      "Do you want to delete this account? No data will be lost except for the account's profile information (Collected contacts and statistics will be kept).",
    deleteBulkMessageConfirmation_other:
      "Do you want to delete these {{count}} accounts? No data will be lost except for the account's profile information (Collected contacts and statistics will be kept).",
    yes: 'Yes',
    no: 'No',
    asc: 'Ascending',
    desc: 'Descending',
    sortOrder: 'Sort Order',
    sortBy: 'Sort By',
    sort: 'Sort',
    shareProfile: {
      text: 'Share Profile',
      title: 'Share',
      wallet: {
        googleWallet: 'QR-Code and Google Wallet',
        appleWallet: 'QR-Code and Apple Wallet',
        online: 'Online',
        offline: 'Offline',
        title: 'QR-Code',
        titleTooltip:
          'Online: Opens your digital Lemontaps profile directly in the browser.\nOffline: The offline QR-code works without internet. Scanning it opens the contact file directly, not your online Lemontaps profile. The saved contact still contains the link to your Lemontaps profile, so the other person can open it at any time.',
        buttonsTooltip:
          'Add Lemontaps to your {{company}} Wallet and share your contact using the QR code in the wallet.',
        dialog: {
          title: 'What are online and offline QR codes?',
          description:
            'Online: Opens your digital Lemontaps profile directly in the browser.\nOffline: The offline QR-code works without internet. Scanning it opens the contact file directly, not your online Lemontaps profile. The saved contact still contains the link to your Lemontaps profile, so the other person can open it at any time.',
        },
      },
      profileLink: {
        title: 'Profile Link',
        label: 'Copy Link',
        copied: 'Copied',
        shareVia: 'Share via',
        shareViaMedia: 'Share via social media',
        tip: '💡 Tip: Add the link to your email signature',
      },
      nfcCards: {
        title: 'NFC-Cards',
        description: 'You can use physical cards to share your profile via tap or QR-Code.',
      },
      qrBackgrounds: {
        title: 'QR Backgrounds',
        description: 'Design Videocall Backgrounds and Phone Lockscreens.',
      },
      shareMenu: {
        qrMobile: 'Create QR Lock Screen',
        qrDesktop: 'Create QR Video Call Background',
        nfcCard: 'NFC Card',
      },
    },
    dateDesc: 'Descending',
    dateAsc: 'Ascending',
    textDesc: 'Sort Z to A',
    textAsc: 'Sort A to Z',
    numberDesc: 'Descending',
    numberAsc: 'Ascending',
    reset: 'Reset',
    exports: 'Exports',
    enrichment: 'Contact Enrichment',
    voiceNotes: 'Voice Notes',
    badgeScanner: 'Fair Badge Scanner',
    leads: {
      import: 'Import',
      importError: 'Error while importing contacts',
      importSuccess: 'Contacts imported successfully',
      importErrorNoOwner: 'Owner is not set for at least one contact',
      enrichmentInProgress: 'Enrichment in progress...',
      scrapingInProgress: 'LinkedIn Scraping in progress...',
      enrichmentInProgressContent:
        'This may take up to 1 minute. You can edit and scan new contacts while enrichment runs in the background.',
      scrapingInProgressContent:
        'This may take up to 1 minute. You can edit and scan new contacts while scraping runs in the background.',
      saveAndEnrich: 'Save and Enrich ✨',
      enrichWithAI: 'Enrich With AI ✨',
      saveAndEnrichWithAI: 'Save and Enrich With AI ✨',
      enrichConfirmationTitle: 'Enrich with AI',
      enrichConfirmationBody: 'Confirm that you want to enrich with AI.',
      enrichStartedSuccessful: 'Enrichment started successfully',
      enrichAlreadyInProgress: 'Enrichment for the lead(s) already in progress',
      enrichMaxLeadEror: 'You can enrich maximum 25 lead at a time',
      enrichedSuccessfully: 'Enriched successfully',
      enrichError: 'Error while enriching',
      enrichErrorFillSomeData:
        'In order to enrich a contact, at least one of the following combination of fields must be filled in:\n{{fields}}',
      xSelected_one: '{{count}} contact selected',
      xSelected_other: '{{count}} contacts selected',
      xAllSelected: 'All contacts are selected',
      searchPlaceholder: 'Name, email, etc...',
      addEditNote: 'Add/Edit Note',
      leadNoteAddSuccess: 'Note added successfully',
      leadNoteAddError: 'Error adding note',
      noLeadsCollected:
        'You haven’t collected any contacts yet. Add a new contact by clicking below.',
      createDate: 'Creation Date',
      noLeadsSearchResult: 'No contacts found',
    },
    enrichedWithAi: 'Enriched with Lemontaps AI',
    mdUnits: {
      error: {
        general: 'Error while deleting units',
        'used-for-acc-claiming': 'Unit is used for account claiming',
        'not-empty': 'Only empty units can be deleted',
      },
      noUnitsFound: 'No units found',
      searchPlaceholder: 'Search for unit name...',
      noUnitsAreAdded: 'You don’t have any units right now. Create a new unit by clicking below. ',
      deleteUnitsMsg_one: 'Are you sure you want to delete the selected unit?',
      deleteUnitsMsg_other: 'Are you sure you want to delete the selected {{count}} units?',
      xAllSelected: 'All units are selected',
      xSelected_one: '{{count}} unit selected',
      xSelected_other: '{{count}} units selected',
      members: 'Members',
      admins: 'Admins',
      viewMembers: 'View Members',
      manageMembers: 'Manage Members',
      addMembers: 'Add Members',
      addMembersExplainer:
        'To add members to your unit you need to visit the user profiles page, select the members and assign them to your selected unit.',
      goToUsers: 'Go to User Profiles',
      addExistingUser: 'Add existing user to unit',
      createNewUser: 'Create new user',
      deleteSuccess: 'Unit deleted successfully',
    },
    downloadPNG: 'Download PNG',
    downloadSVG: 'Download SVG',
    mdLeads: {
      owner: 'Owner',
      xUnitsSelected_one: '{{count}} selected',
      xUnitsSelected_other: '{{count}} selected',
      xAllUnitsSelected: 'All are selected',
      successCreate: 'Unit created',
      noUnit: 'No unit',
      edit: 'Edit',
      unit: 'Unit',
      status: 'Status',
      membersView: 'View members',
      view: 'View',
      loadingUnits: 'Loading Units',
      noSelectedUnits: 'There are no users in this unit yet',
      addEmployeeToUnit: 'Adding existing employees to a unit',
      editUnitHeader:
        'Go to the profiles page, select the users you want to assign to a unit, and then select the option "Assign to unit".',
      loadingUnitsError: 'Error loading units',
      unitNameExists: 'A unit with that name exists already',
      addUsersToUnit: 'Add existing users to the unit',
      noUnitSelected: 'At least one unit must be selected',
      firstCreateUnit: 'You must create a unit first',
      noRoleSelected: 'At least one role must be selected',
      unassignFromUnit: 'Unassign from unit',
      confirmRemoveUnit_one: 'Do you want to remove the selected profile from the unit?',
      confirmRemoveUnit_other: 'Do you want to remove the selected profiles from the unit?',
      removeFromUnit: 'Remove from unit',
      removingFromUnit: 'Removing from unit',
      successRemovingFromUnit: 'Removed from unit',
      toProfiles: 'To the Profiles page',
      AssignUnitError: ' Error assigning units',
      assignUnitWarning:
        'The selected accounts are assigned to the units that are selected here and removed from the units that are not selected here.',
      members: 'Members',
      deleteUnits_one: 'Are you sure you want to delete this unit?',
      deleteUnits_other: 'Are you sure you want to delete these units?',
      unitAdmins: 'Unit Admins',
      errorReadUnits: 'Error while loading units',
      contact: 'Contact',
      notes: 'Notes',
      multiNotes: 'Potentially multiple notes',
      date: 'Date',
      vcf: '.vcf',
      deletedAccount: "Account doesn't exist any more",
      accountDeleted: 'Deleted account',
      connectedAccounts: 'Owner',
      connectTo: 'Owner',
      downloadCSV: 'CSV-Export',
      editFormTitle: 'Edit Contact',
      editSuccess: 'Contact updated successfully',
      editError: "Contact couldn't be updated!",
      addFormTitle: 'Add contact',
      addSuccecss: 'Contact added successfully',
      addError: "Contact couldn't be added",
      uploadPhoto: 'Upload Photo',
      download: 'Download',
      metOn: 'Created on',
      metAt: 'Created on',
      fetchError: 'Please reload the page and try again',
      deleteContact: 'Delete contact',
      deleteSuccess: 'Contact deleted successfully',
      deleteError: "Contact couldn't be deleted",
      tooltipMultiAccountsConnected:
        'This contact has been collected by several employees. By selecting an employee in the dropdown below, you can switch between the contact information entered by each one of them.',
      export: 'Exports',
      errorSaving: 'Error while saving, at least one field is required',
      errorSavingValidation: 'Error while saving, at least one field is not correctly formatted',
      crmExport: {
        confirmDialog: {
          title: 'Export',
          text_one: 'You are about to export {{count}} contact to {{name}}.',
          text_other: 'You are about to export {{count}} contacts to {{name}}.',
          textAll: 'You are about to export all contacts to {{name}}.',
          campaignAccordionTitle: 'Assign to a campaign',
          campaignTitle: 'Do you want to assign the selected contacts to a campaign?',
          selectCampaign: 'Select a campaign',
          campaignHelper:
            "Note: you don't need to select a campaign and can just proceed with the export",
          campaignAutoAssignInfo: 'An admin has configured this campaign assignment.',
          configurationsAccordionTitle: 'Fill in required fields from CRM',
          configurationsInfo:
            'If you have required custom fields configured in your CRM, you must provide a value here, otherwise the export will fail. If you do not see a field here, click the button below to refresh.\n\nIf you are an admin, you can also configure global default values in the CRM settings page.',
          noConfigurations: 'No required fields available.',
          refreshConfigurations: 'Refresh custom fields configuration',
          leadObjectTypeWarning:
            'For at least one contact in the selection, it is not specified whether it should be exported to the CRM as a contact or lead. Make a selection here for all these contacts, or go back and make an individual selection for the individual contacts.',
        },
        startSuccess: 'Export started',
        startFail: 'Error while starting the export',
        emptySelection: 'Select contacts to export',
      },
      metBy: 'Owner',
      showDeleted: 'Show deleted',
      deleteLeadsMsg_one: 'Are you sure you want to delete the selected contact?',
      deleteLeadsMsg_other: 'Are you sure you want to delete the selected {{count}} contacts?',
      crmExportStatus: 'Crm Export Status',
    },
    owner: 'Owner',
    deletedAt: 'Deleted On',
    translations: {
      title: 'Translations',
      description:
        'Translate the digital business card profiles of your team. You can translate the standard text, contact information, link names, links and file names. You can also decide not to show information in certain languages.',
      language: {
        updateSuccess: 'Languages updated successfully',
        updateError: 'Error updating language!',
        title: 'Supported Languages',
        description:
          'The language of the profile depends on the device settings the profile is shared to. If the device language is not known the profile gets displayed in the fallback language. Set your input language to the language that you create your profiles in the admin dashboard with.',
        types: {
          input: 'Input Language',
          fallback: 'Fallback Language',
        },
        button: 'Add a Language',
        addModal: {
          title: 'Add a new Language',
          languageLabel: 'Select Language',
          typeLabel: 'Type (optional)',
        },
        notEditable:
          'You cannot remove the input or fallback language labels. Instead, select a different language to move the labels to.',
        editModal: {
          title: 'Edit Language',
          languageLabel: 'Language',
          typeLabel: 'Type (optional)',
        },
        deleteModal: {
          errorMainLangDelete:
            'You cannot delete the input or fallback languages. First, select another language as the input or fallback language.',
          title: 'You are about to remove support for a language',
          description:
            'This language will no longer be supported on profiles of your employees. Profile visitors whose devices are configured to this language will instead see the profile in the fallback language.',
        },
      },
      packs: {
        title: 'Language-Packs',
        description:
          'Download the language packs and add or modify translations. If you leave a field blank in the translation, the value of the Input Language is taken for that field. If you wish to delete a field, write “{{token}}”. Upload a zip-file containing csv-files with the same names as in the download only.',
        uploadLabel: 'Click to upload or drag and drop',
        link: 'Download current Language Pack configuration',
        notAllowedTitle: 'Ask your admin for permission',
        notAllowedBody: 'Your admin does not allow unit-admins to edit translations.',
        uploadSuccess: 'Language packs updated.',
        filename: 'language-pack',
        errors: {
          generic: 'Error',
          fileNotFound: 'File no found',
          uploadError: 'Upload failed. Check the file formats and contents.',
          invalidFilename:
            'At least one invalid file name. Name the files exactly as in the downloaded language pack.',
          api: {
            LIMIT_FILE_SIZE: 'File is too big.',
            [ERROR_KEYS.TRANSLATIONS_UPLOAD_NO_DATA]: 'File could not be read.',
            [ERROR_KEYS.TRANSLATIONS_UPLOAD_INVALID_FILE_TYPE]: 'Invalid file type.',
            [ERROR_KEYS.TRANSLATIONS_UPLOAD_READ_ERROR]:
              'Error reading the file. The uploaded ZIP file may be corrupted.',
            [ERROR_KEYS.TRANSLATIONS_UPLOAD_INVALID_FILENAMES_OR_NO_PERMISSION]:
              'Only file names that are also included in the downloaded language pack are allowed. Either incorrectly named files were uploaded, or you are not authorized to edit some of the categories.',
            [ERROR_KEYS.TRANSLATIONS_UPLOAD_CSV_PARSE_ERROR]:
              '"{{filename}}": Error reading the data. Make sure that the columns and rows are formatted correctly.',
            [ERROR_KEYS.TRANSLATIONS_UPLOAD_INVALID_KEYS]:
              '"{{filename}}": Some or all translation keys are invalid.',
          },
        },
      },
    },
    errorDeletingUsers_one: 'Error while trying to delete Account',
    errorDeletingUsers_other: 'Error while trying to delete Accounts',
    errorFetchingProfiles: 'Error while fetching profiles',
    successfullyUsersDeleted_one: 'Accounts deleted successfully',
    successfullyUsersDeleted_other: 'Account deleted successfully',
    deleteAccounts_one: 'Delete Account',
    deleteAccounts_other: 'Delete Accounts',
    onlineQrCodes: 'Online QR-Codes',
    offlineQrCodes: 'Offline QR-Codes',
    employeesCsv: 'CSV',
    employeesXlsx: 'Excel',
    profileLinks: 'Profile Links',
    onlineAppleWallets: 'Online Apple Wallet-Passes',
    onlineGoogleWallets: 'Online Google Wallet-Passes',
    offlineAppleWallets: 'Offline Apple Wallet-Passes',
    offlineGoogleWallets: 'Offline Google Wallet-Passes',
    actionTooltips: {
      onlineQrCodesPNG:
        'You will export a Lemontaps QR-Code which will redirect to the digital profile of the selected users.',
      onlineQrCodesSVG:
        'You will export a Lemontaps QR-Code which will redirect to the digital profile of the selected users.',
      offlineQrCodesPNG:
        'You will export a Lemontaps QR-Code which will contain the vcard of the selected users.',
      offlineQrCodesSVG:
        'You will export a Lemontaps QR-Code which will contain the vcard of the selected users.',
      csv: 'You will export all user information in the table in CSV-Format.',
      xlsx: 'You will export all user information in the table in Excel-Format.',
      links: 'You will export a CSV-File with the profile links of the selected users.',
      mobileBg:
        'You will export a QR-Code Background for the mobile lockscreen of the selected users.',
      videoBg: 'You will export a QR-Code Background for the videocall tool of the selected users.',
      onlineAppleWallet:
        'You will export a zip file containing all the Apple Wallet-Passes for the selected users. The passes will include a QR-Code which will redirect to the respective digital profile.',
      offlineAppleWallet:
        'You will export a zip file containing all the Apple Wallet-Passes for the selected users. The passes will include a QR-Code which which will contain the vcard of the respective user.',
      onlineGoogleWallet:
        'You will export a csv file containing all the URLs to Google Wallet-Passes for the selected users. The passes will include a QR-Code which will redirect to the respective digital profile.',
      offlineGoogleWallet:
        'You will export a csv file containing all the URLs to Google Wallet-Passes for the selected users. The passes will include a QR-Code which which will contain the vcard of the respective user.',
    },
    gettingCommonLinks: 'Getting common links...',
    commonLinksFound: 'Common links found!',
    commonLinksNotFound: 'No common links found!',
    xProfilesSelected: '{{count}} selected',
    xProfilesSelectedLong: '{{count}} profiles selected',
    xAllProfilesSelected: 'All are selected',
    bulkActions: {
      chooseActionType: 'Choose action type',
      chooseField: 'Choose field',
      value: 'Value',
      distribute: {
        title: 'Distribute via E-Mail',
        wallet: {
          tooltip:
            'Distribute Google and Apple Wallet business cards to the selected profiles via email.',
          successMsg: 'Wallet emails successfully sent.',
          errorMsg: 'Error while sending emails, please reload the page and try again.',
        },
      },
      invite: {
        title: 'Send Invitation Emails',
        confirm: 'Are you sure you want to send invitation emails to the selected profiles?',
      },
    },
    inviteSelected: 'Send invitation emails',
    inviteSelected_one: 'Send invitation email',
    inviteSelected_other: 'Send ({{count}}) invitation emails',
    bulkUpdated: 'Profiles updated',
    bulkFailed: 'Error updating profiles',
    bulkInvitedSync: 'Invitation emails sent',
    bulkInvitedAsync:
      'You will receive an e-mail as soon as the profiles have been invited. This may take a little while.',
    invited: 'Invitation email sent',
    passwordMessage: 'Your password should contain at least',
    characters: '8 characters',
    oneNumber: 'One number',
    oneSpecialCharacter: 'One special character',
    next: 'Next',
    welcomeMD: 'Welcome to the Management Platform',
    problemsMD: 'If you have any problems with the login.',
    clickHere: 'Click here!',
    welcomeBackMD: 'Welcome Back!',
    forgotMD: 'Forgot your access data?',
    resetPasswordMD: 'Reset your password',
    emailAddress: 'Email Address',
    password: 'Password',
    welcomeMessage: 'Welcome to Lemontaps',
    logIn: 'Login in',
    passwordForgot: 'Forgot your password?',
    choosePersonalLink: 'Choose your personal link',
    yourUsername: 'your username',
    signUpMessage: 'for your Lemontaps account in seconds.',
    alreadyRegistered: 'Already have an account?',
    signUp: 'Signup',
    confirmPW: 'Confirm Password',
    consentMessage:
      'By using this service you are agreeing to the terms and conditions and privacy policy.',
    firstNameONB: "Hey, welcome on board 🎉 What's your first name?",
    lastNameONB: "Hi {{firstName}} 🎉 What's your last name?",
    addProfileImageONB: 'Add your profile photo',
    changeMessage: 'You can change this later.',
    skip: 'Skip',
    addHeadlineONB: 'Add a headline about yourself',
    addHeadlineMessage:
      'This is a short description of who you are or what you do, e.g. job position, personality traits.',
    headline: 'Headline',
    addPhoneONB: 'Add your phone number',
    addPhoneMessage:
      'This phone number can be shared with your contacts. You can always change it.',
    linkLemontap: 'Link your Lemontap or Lemoncard to your profile',
    activationCodeMessage: 'You can find the code on the packaging underneath your product.',
    enterCode: 'Enter code',
    connect: 'Connect',
    continueWithoutLemontap: 'Continue without a Lemontap',
    learnHowONB: 'Learn how to tap your Lemontaps with other phones',
    connectSuccessfully:
      'You have successfully connected your Lemontaps! You can now begin to set up your profile.',
    validateAccount: 'Validate your account',
    sentEmail:
      "We've sent you an email with a link to validate your account. Please check your inbox or your spam folder.",
    failreceiveEmail: "I didn't receive the email",
    findInstructions: "Click here to always find the instructions for 'How to tap'",
    contactInfo: 'Contact Information',
    contactInfoBulkHint:
      'The data configured here will override the resp. field of the selected profiles.',
    contactInfoBulkHintDeleted:
      'The attribute you choose here will be emptied on all the selected profiles.',
    accountInfo: 'Account Information',
    german: 'German',
    english: 'English',
    language: 'Language',
    createProfile: 'Create New Profile',
    shareNFC: 'Share to phones without NFC',
    scanQRC: 'Let them scan your QR-Code which you can find in your profile',
    loginEmail: 'Login with Email',
    pleaseLogin: 'Please login with the email address and the password from the packaging.',
    pageNotFound: 'Oops! Page not found 🙈',
    weareSorry:
      'We are sorry for the incovenience . It looks like you’re trying to access a page that either has been deleted or never existed.',
    backHome: 'Back to Homepage',
    enterLinkerror: 'Please enter your link',
    nameLinkerror: 'Please name your link',
    enterUsernameerror: 'Please enter your username',
    enterMessage: 'Please enter {{subject}}',
    phoneSubject: 'a phone number',
    usernameSubject: 'a username',
    linkSubject: 'a link',
    one: '',
    nameFileerror: 'Please name your file',
    correctLink: 'Please enter a correct link',
    serverError: 'Server Error.',
    usernameCharcters: 'Username must be longer than 3 characters.',
    matchingPasswords: "Password and Confirm Password doesn't match!",
    connectMD: 'You have to connect a Lemontaps',
    errorMDMail: 'You have to type in a valid email',
    errorMDFullName: 'You have to type both first and last names',
    changesSaved: 'Changes saved!',
    codeRead: {
      title: 'Scan the QR Code of the card you want to connect',
      missed: 'Malformed QR-Code!',
      loadingMD: 'Checking if valid...',
      successMD: 'The code is valid!',
      errorMD:
        'This QR-Code is either in use or incorrect. Please contact customer support if the card is not used, but shown as incorrect.',
      btnText: 'Connect a new card',
      btnSuccessText: '1 card will be connected',
      connectHeadlineMD: 'Optional: Connect a new Card with the profile',
      connectMessageMD:
        'Scan the QR-Code on the card and the profile will be automatically connected with the card.',
      enterCodeText: 'or enter the code manually',
      switchCamera: 'Switch Camera',
      problems: 'Problems? Scan the QR-Code using your phone.',
      startNow: 'Start now',
      uploadImage: 'Upload image of QR-Code',
    },
    verified: 'verified',
    notVerified: 'not verified',
    imageUpdatedMD: 'Image updated!',
    createdSuccessMD: 'Created successfully!',
    status: 'Status',
    statusActive: 'Active',
    statusInvited: 'Invited',
    statusUninvited: 'Not Invited',
    sendInvite: 'Send Invite',
    sendInviteTooltip:
      'Do you want to send out an invitation link automatically when creating this profile? You can also do this later.',
    resendInvite: 'Resend Invite',
    invitationMD: `Do you want to send out an invitation link automatically when creating this profile?
                       You can also do this later.`,
    cropImage: 'Position and crop your picture',
    requestDelete: 'Are you sure?',
    deleteMessageLink: 'Your link will be deleted.',
    deleteMessageFile: 'Your file will be deleted.',
    deleteMessageAddress: 'The address will be deleted.',
    genericDelete: 'This action is irreversible. Are you sure you want to continue?',
    deleteFile: 'Delete File',
    deleteIt: 'Yes, delete.',
    DBScanQR: 'Scan the QR-Code from the card with your phone',
    DBOpenlink: 'Open the scanned link and go to the URL bar',
    DBUseCharac: 'Use the characters after the slash "/" of the URL lemontaps.com/"',
    DBUseCharac2: 'as the activation code and type this code here below',
    YourPlan: 'Your Plan',
    FirstYear: 'in the first year',
    billingHeadingSecond: 'and afterwards 29.99€/year',
    active: 'Active',
    activeUppercase: 'ACTIVE',
    cancelPlan: 'cancel plan',
    mailTemplateFirst: 'Please send us an email to ',
    mailTemplateSecond: ' to cancel your subscription.',
    mailTemplateActive: ' to activate your subscription.',
    billing: 'Billing',
    onBoard: 'Hey, welcome on board!',
    yourName: 'Whats your name?',
    cardInfo: 'Add more information to your digital business card.',
    learnHowToTap: 'Learn how to tap',
    lemonTapsPhones: 'your Lemontaps with other phones',
    subscription: 'Subscription Plan',
    newCardDetected:
      'A new NFC-Card has been recognized. Would you like to link it to your profile?',
    connectCard: 'Connect NFC-Card?',
    addCodeSuccess: 'You have successfully connected your card with your profile!',
    verification: {
      verifyEmail: 'Verify your email',
      subHeader:
        'We sent a verification link to <0>{{email}}</0>.<1></1>Please check your inbox or spam folder.',
      notReceived: "Didn't receive email?",
      resendEmail: 'Resend',
      sendSuccess: 'Sent',
      sendError: 'Failed',
      wrongEmail: 'Wrong Email?',
      changeEmail: 'Change Email',
      logout: 'Logout',
      back: 'Back to login',
    },
    emailTooltipCreate:
      'This is the email address which will be used for the registration and login.',
    emailTooltipEdit: `This field only determines the email address being displayed on the profile page and the downloaded contact.
                      If you want to change the email address used to login with, please open the tab "Account" above.`,
    metaTagTitle: 'Your digital and sustainable business card',
    metaTagDescription:
      'Manage and share your contact information, links and documents efficiently and without a waste of resources! Lemontaps is the original and leading provider in Germany for digital business card!',
    metaTagProfileDescription: 'Connect with me now and check out my links and documents!',
    register: 'Register',
    newToLt: 'If you are new to Lemontaps',
    login: 'Login',
    fileUploaded: 'File uploaded successfully',
    addContactLead: 'Add a new Contact',
    leadType: 'Lead Type',
    exportToCRM: 'Export & Import to CRM',
    importToCRM: 'Import File to your CRM',
    step1: 'Step 1',
    step2: 'Step 2',
    downloadFile: 'Download File',
    chooseFileFormat: 'Choose the format you want to export.',
    downloadCSV: 'Download CSV',
    downloadXLSX: 'Download XLS',
    importInstructions: 'It is very easy - we have provided instructions for different CRMs',
    learnMore: 'Learn more',
    howToImport: 'How to import the file to your CRM',
    qrCodeBG: 'QR-Code Background',
    qrWallpaper: 'QR-Wallpaper',
    videocallBG: 'Videocall background',
    videocallTxt:
      'Easily exchange your business cards even at online events or meetings with your Lemontaps QR-Code in a videocall background. The recommended background size is at least 1500x1000.',
    bgImageTitles: {
      choosePosition: 'Choose position',
    },
    qrCodeBackground: {
      alerts: {
        noSelection: {
          title: 'No image selected',
          content: 'You first have to upload an image.',
        },
        noActionAllowed: {
          title: 'Not allowed',
          content:
            'You cannot download any QR-Code background here. Ask your admin to either upload a preset of images to choose from or to allow uploading your own images here.',
        },
      },
      type: 'Choose QR-Code Type',
      typeTooltip:
        'Online: Opens directly your digital Lemontaps profile in the browser.\n Offline: The offline QR-code works without internet. Scanning it opens the contact file directly, not your online Lemontaps profile. The saved contact still contains the link to your Lemontaps profile, so the other person can open it at any time.',
      image: 'Choose Image',
      imageTooltip:
        'Any format, min width of {{limit}}px recommended.\nTipp: Use the format of your phone!',
      download: 'Set QR-Code Design & Download',
      online: 'Online',
      offline: 'Offline',
      uploadSubtext: 'SVG, PNG, JPG or GIF (any format, minimum width: {{limit}}px)',
      howToUseVC: 'How do I use my videocall background in Zoom, Teams or Hangouts?',
      positions: {
        top: 'Top',
        middle: 'Middle',
        bottom: 'Bottom',
        left: 'Left',
        right: 'Right',
        default: 'Default',
      },
      mobile: {
        title: 'QR Phone Background',
        header:
          'Always have your Lemontaps profile handy on a QR-Code on your Smartphone lockscreen.',
        label: 'Phone Background',
      },
      videocall: {
        title: 'QR Videocall Background',
        header:
          'Easily exchange your business cards even at online events or meetings with your Lemontaps QR-Code in a videocall background.',
        label: 'Videocall Background',
      },
    },
    download: 'Download',
    imageUpload: 'Upload Image',
    generalQRImgError: 'Please reload the page and try again',
    uploadImgError: 'Please upload an image file (.jpg, .jpeg, .png)',
    uploadImgSuccess: 'Image successfully uploaded',
    downloadImgSuccess: 'Download was successfully',
    mobileBG: 'Mobile background',
    uploadedImgSizeErr: `The image must have a width of at least {{x}}px.`,
    uploadedMobileImgErr: 'The image must be vertical with a minimum {{x}}px width.',
    notes: 'Notes',
    writeNoteHere: 'Write your notes here',
    contactInformation: 'Enter Contact Information',
    scanBusinessCard: 'Upload business card image',
    uploadPhoto: 'Upload Photo',
    dataWillBeEntered: 'Data must be entered',
    editContact: 'Edit Contacts',
    leadSegment: 'Lead Segment',
    or: 'or',
    createInProgress: 'Create feature is in progress',
    editInProgress: 'Edit feature is in progress',
    missingInputPrompt: 'You have to type in a {{param}}',
    fullName: 'Full Name',
    firstAndLastName: 'First & Last Name (in one row)',
    name: 'name',
    email: 'Email 1',
    workEmail: 'Email 2',
    workEmail2: 'Email 3',
    businessCardLink: 'Business Card Link',
    correctEmail: 'Please type in a correct email address',
    succAdded: 'Successfully added!',
    consentToData: 'Please give your consent according to the GDPR laws.',
    shareBusinessCard: 'Share your business card with {{name}}',
    shareContactDetails: 'Share your contact details with {{name}}',
    retakePic: 'Retake picture',
    gdprConsent: {
      pt1: 'By submitting I confirm that I have read the',
      pt2: 'and that I consent to the processing of my contact details in the contact management of the Lemontaps user, as well as that of their company, if applicable',
      pt3: 'You can revoke this consent at any time.',
      gdpr: 'privacy policy',
    },
    privacyPolicy: 'GDPR',
    termsAndConditions: 'T&C.',
    and: ' and ',
    Send: 'Send',
    saveContactOf: `Save {{name}} contact`,
    modalEmailPlaceholder: 'Send this contact to your email',
    dataDisclaimer: 'We do not sell or share your data.',
    lgFollowUp_contSave: 'Do you also want to save {{name}} contact information?',
    lgFollowUp_contConn: 'Do you also want to share your contact information with {{name}}?',
    lgFollowUp_doneSave: 'We have sent you an email with {{name}} contact card!',
    lgFollowUp_doneSaveDown: 'Successfully downloaded {{name}} contact!',
    lgFollowUp_doneConn: 'Your contact information was successfully sent to {{name}}!',
    leadSuccess: 'Your contact was digitally transferred!',
    leadSaveSuccess: 'Saved successfully',
    leadError: 'Error while saving.',
    deleteLead: 'Delete Contact',
    deleteLeadSuccess: 'Contact deleted.',
    deleteLeadError: 'Error while deleting.',
    deleteLeadMsg: 'Your contact will be deleted.',
    fileTypeNotSupported: 'File type not supported.',
    uploadRestrictedTo: 'Please upload jpg, jpeg, png, gif files.',
    maxUpload: 'Max. upload size should be {{mb}} MB.',
    EditBioSuccess: 'Data save successfully.',
    editDetails: 'Edit Details',
    profiles: 'Profiles',
    units: 'Units',
    unit: 'Unit',
    mainUnit: 'Main Unit',
    subUnit: 'Sub Unit',
    mainUnitTooltip: `The main unit is decisive for unit-specific settings. If, for example, individual profile designs are defined for all units, then the profile will appear with its main unit's profile design.`,
    otherUnits: 'Other Units',
    otherUnitsTooltip: `Accounts can be assigned to multiple units. Thus, in addition to the account's main unit, other units can be defined. A unit admin can always edit all profiles in all units in which he/she is a member.`,
    unitsText: 'Group users into units. These can also be managed by sub-admins themselves.',
    addUnit: 'Add unit',
    editUnit: 'Edit unit',
    searchUnits: 'Search Units',
    createUnit: 'Create unit',
    noUnitData: 'There are currently no units available',

    guides: 'Get Started',
    guideHeader: 'Los geht’s mit Lemontaps',
    guideSubHeader:
      'Hier finden Sie einer Übersicht zu Guides und Hilfen, wie Sie Lemontaps einrichten und benutzen können.',
    connectionsSubHeader:
      'Find all captured contacts/leads of all employees in one place, which were collected using the contact form at the bottom of the public profile.',
    // MD Customization strings start
    companySettings: 'Company Settings',
    globalCompanyData: 'Global Company Data',
    globalCompanyDataSub: 'Add and manage your default company data.',
    globalCompanyAddButton: 'Add Data',
    organisationPageHeader: 'Organization',
    filesPageHeader: 'Files',
    addressesPageHeader: 'Addresses',
    footerPageHeader: 'Footer',
    linksPageHeader: 'Links',
    qrCodePageHeader: 'QR-Code Backgrounds',
    contactFormPageHeader: 'Contact Form',
    standardData: 'Data Templates',
    emailTemplatesPageHeader: 'Email Templates',
    teamSettings: 'Team Settings',
    leadForm: 'Contact Form',
    customizationSub: 'Customize your Lemontaps Platform according to your company’s needs.',
    customizeDesign: 'Customize Design',
    general: 'General',
    organisation: {
      title: 'Organization',
      name: 'Name of your organization',
      nameTooltip: 'The name appears e.g. in the email subjects, or in the browser tab title.',
      nameRequired: 'Organization Name is required.',
      nameFailed: 'Failed to update Organization Name.',
      internalDesign: 'Internal design of the platform',
      internalDesignFailed: 'Failed to update Internal Design.',
      bannerUpgradeNow: 'Upgrade now.',
      bannerText: 'The Internal Design is not available in your current package.',
      lightBackground: 'Logo for light backgrounds:',
      lightBackgroundTooltip: "The Lemontaps Logo will get replaced with your company's logo.",
      otherLightBackground: 'Upload another logo file for dark backgrounds:',
      logoLimit: 'only .png with transparent background, max size {{x}}MB',
      primaryButtonColor: 'Primary Button Color',
      sidebarColor: 'Navigation Sidebar Color',
      sidebarColorText: 'Navigation Sidebar Text Color',
      sidebarColorActive: 'Navigation Sidebar Active State Color',
      sidebarColorActiveText: 'Navigation Sidebar Active State Text Color',
      resetColors: 'Reset Colors',
    },
    loginAndProvisioning: {
      title: 'Login and Provisioning',
      domainControl: {
        title: 'Domain Control',
        description:
          "Verify your company's email domain(s) to gain full control over all accounts. This allows you to ensure that all your employees are automatically added to your team upon registration. Domain verification is also a prerequisite for Single Sign-On (SSO) and user synchronization.",
        buttonTitle: 'Manage domains',
      },
      sso: {
        title: 'Single Sign-On (SSO)',
        description:
          'SAML 2.0 or OIDC based single sign-on (SSO) gives your team members access to Lemontaps with their company credentials.',
        buttonTitle: 'Manage SSO',
      },
      scim: {
        title: 'User Provisioning',
        description:
          'Automatically provision and deprovision users and their profile information from your identity provider.',
        buttonTitle: 'Manage user provisioning',
      },
    },
    visibility: {
      accountSettings: {
        title: 'Account Settings / More (Desktop & Mobile)',
        tooltip:
          'Controls the visibility of elements in the account settings page, as well as in the "More" page on mobile.',
        accountSettings: {
          title: 'Account Settings (Desktop only)',
          tooltip:
            'You can hide the entire account settings on desktop. On mobile, this is not possible. You can still manually hide individual elements from the mobile account settings page.',
        },
        externalLink: {
          title: 'External Links',
          tooltip:
            'This menu item is only relevant if it was manually configured by a Lemontaps configuration admin. You can ignore this setting otherwise.',
        },
        paperCardOrderSystem: {
          title: 'Paper Business Card Order System',
          tooltip:
            'The link to the paper business card order system for individual employees. This is only relevant if you have a paper business card order system configured. You can ignore this setting otherwise.',
        },
        prefilledFormLink: {
          title: 'Form Links',
          tooltip:
            'This menu item is only relevant if it was manually configured by a Lemontaps configuration admin. You can ignore this setting otherwise.',
        },
        changeEmail: {
          tooltip: 'Menu item to let users change their email address.',
        },
        changePassword: {
          tooltip: 'Menu item to let users change their password.',
        },
        cookies: {
          tooltip: 'Menu item to let users manage their cookies.',
        },
        changeLanguage: {
          tooltip: 'Menu item to let users change the language of the platform.',
        },
        teamManagement: {
          title: 'Team Management (Mobile only)',
          tooltip:
            'Menu item linking to the management dashboard. May be displayed in the "More" menu on mobile.',
        },
        nfcCards: {
          title: 'NFC Cards (Mobile only)',
          tooltip: 'Menu item to let users manage their NFC cards.',
        },
        analytics: {
          title: 'Analytics (Mobile only)',
          tooltip: 'Menu item to let users view analytics data.',
        },
        addApp: {
          title: 'Add to Homescreen (Mobile only)',
          tooltip:
            'Menu item to let users install the Lemontaps app to their mobile device (as a PWA).',
        },
        help: {
          title: 'Help (Mobile only)',
          tooltip: 'Menu item to let users contact the Lemontaps support team.',
        },
      },
      title: 'Visibility',
      description: 'You can hide certain pages or elements for both end users and admins',
    },
    unitSettings: {
      title: 'Unit Settings',
      multipleUnits: {
        title: 'Assign to Multiple Units',
        description:
          "Allow the assignment of one account to multiple units. One of the assigned units must be marked as the main unit. This unit's settings will determine the behavior of the account (profile design, edit rights, etc.). If this setting is turned off, each account may only be assigned to one unit.",
      },
    },
    setEditRights: 'Set Edit Rights',
    profileDesign: 'Profile Design',
    profileDesignSub:
      'Customize the design of the digital profile - decide about colors and images.',
    profileDesignInfo: {
      unitAdmin:
        'Customize the digital profiles in your unit according to your Corporate Design. The settings that you choose in this section will be applied to all digital profiles in your unit.',
      themeAdmin: {
        global:
          "Customize your digital profiles according to your Corporate Design. The settings that you choose in this section will be applied to all your digital profiles that don't have unit-specific settings.",
        unit: 'Customize your digital profiles in the selected unit according to their Corporate Design. The settings that you choose in this section will be applied to all digital profiles in that unit.',
      },
    },
    boxForm: 'Box-Form',
    rounded: 'Rounded',
    squared: 'Squared',
    buttonColors: 'Button-Colors',
    AdditionalImages: 'Additional Cover Images',
    strSaveContact: '“Save Contact”',
    genericWebsite: 'Generic Website Link',
    images: 'Images',
    Oops: 'Oops! Something went wrong!',
    anErrorHasOccured:
      'An unexpected error has occurred, we apologize for that. If the error still occurs, please contact our support team. You can go to the home page by clicking the "Go to Home" button. If you want to tell us something related to this error message, then click on "Contact us" to send a message to our support team.',
    goHome: 'Go to Home',
    message: 'Enter your message to our support team here',
    submitText: 'Submit',
    errorMessageSentSuccess: 'We received your message and will deal with it shortly',
    more: 'more',
    less: 'less',
    defaultCoverImage: 'Default-Cover Image',
    uploadCoverImage: 'Upload cover image',
    uploadFurtherCoverImage: 'Upload further cover image',
    uploadMoreImages: 'Upload title images that the employees must choose from',
    defaultAvatar: 'Default Profile Picture Avatar',
    logo: 'Logo',
    uploadLogo: 'Upload Logo',
    policies: '4. Policies',
    linkToImprint: 'Link to Imprint',
    linkToPrivacyPolicy: 'Link to privacy policy',
    nameOfYourCompany: 'Name of your company',
    addCopyRight: 'Add copyright?',
    allRightsReserved: '(© @year [your company name]. All rights reserved)',
    allRightsReservedPublic: 'All rights reserved',
    editRightsL: 'Edit Rights for employees',
    unitsGlobalSelect: 'Global (Default)',
    unitsSelectLabel: 'Select Unit',
    profilesSelectLabel: 'Choose Profile',
    editRights: {
      editable: 'Editable',
      nonEditable: 'Non-Editable',
      editApprovalNeeded: 'Require approval',
      title: 'Edit Rights',
      mainHeading: 'Edit rights for employees',
      unitHeading: 'Edit rights for unit admins',
      mainTabLabel: 'For employees',
      unitTabLabel: 'For unit-admins',
      unitOverrideLabels: {
        visibilityConfig: {
          label: 'Visibility',
        },
        profileDesign: {
          label: 'Profile Design',
        },
        editRights: {
          label: 'Edit Rights',
        },
        emailSignature: {
          label: 'E-Mail Signature',
        },
        emailTemplates: {
          label: 'E-Mail Templates',
        },
        walletConfig: {
          label: 'Wallet Config',
        },
        qrBgImages: {
          label: 'QR Code Background Config',
        },
        qrCodeConfig: {
          label: 'QR Code Config',
        },
        userDefinedTranslations: {
          label: 'Translations',
          subsettings: {
            heading: 'Translation Rights',
            subheading:
              'Grant Unit Admins access to certain translation files. They will have access to the whole file for the whole organisation. Every change they make, will affect the global file.',
            labels: {
              'profile--links': 'Links',
              'profile--files': 'Files',
              'profile--system-labels': 'System Labels',
              'profile--position': 'Positions',
              'profile--role': 'Roles',
              'profile--division': 'Divisions',
              'profile--bio': 'Bio Texts',
              'profile--addresses': 'Addresses',
              'profile--firstName': 'First Names',
              'profile--lastName': 'Last Names',
              'profile--company': 'Company Names',
              'profile--homepage': 'Homepage URLs',
              'profile--other-contact-info': 'Other Contact Info',
              'profile--urls': 'URLs',
            },
          },
        },
      },
      fields: {
        detailsEditMode: 'Contact Information',
        profileImageEditMode: 'Profile Picture',
        bannerImageEditMode: 'Profile Banner',
        logoImageEditMode: 'Header Logo',
        linkEditMode: 'Links',
        fileEditMode: 'Files',
        allowOwnQrBgImage: 'Individual QR-backgrounds',
        rebuyCards: 'Re-Ordering Cards',
        singleUserCrmPush: 'Allow users to push leads to CRM',
        profileShare_uidParam: 'Switch between profile designs',
      },
      tooltips: {
        allowOwnQrBgImage:
          'Determines whether your employees are allowed to upload their own images to create QR-backgrounds with.',
        rebuyCards:
          'Determines whether employees are displayed a link to our re-order form on the page "Share Profile" -> "NFC Card"',
        profileShare_uidParam:
          'If enabled, your employees will be able to switch between profile designs available to them. They will also be able to select the global default.',
      },
      fieldsSubHeadings: {
        detailsEditMode:
          'Here you can define for each profile attribute whether it may be edited by your employees. In this way, you can prevent individual attributes from being edited by your employees while you allow the editing of other attributes.',
        linkEditMode:
          'You can decide here which link variants may be created by your employees. As an admin you can still create all variants.',
      },
    },
    editRightsSub:
      'Decide on which information employees can change by themselves and which information only admins can change.',
    editRightsInfo: {
      unitAdmin:
        'Which information can employees change? Which information shall only be changed by the admins? The settings that you choose in this section will be applied to all users in your unit.',
      themeAdmin: {
        global:
          "Which information can employees change? Which information shall only be changed by the unit-admins or global admins? The settings that you choose in this section will be applied to all your digital profiles that don't have unit-specific settings",
        unit: 'Set specific edit rights for the selected unit.',
      },
    },
    editRightsBlockedFieldsTeaser:
      "Your current plan doesn't include the ability to set attribute-level edit rights.",
    blockedBioFieldsSubtext:
      'Here you can define for each profile attribute whether it may be edited by your employees. In this way, you can prevent individual attributes from being edited by your employees while you allow the editing of other attributes.',
    blockedLinkTypesSubtext:
      'You can decide here which link variants may be created by your employees. As an admin you can still create all variants.',
    profilePreview: 'Example Profile Preview:',
    comingSoon: 'Coming Soon',
    mdguide: {
      tasks: 'Tasks',
      pageHeader: 'Get started as an admin',
      watchIntro: 'Watch Intro',
    },
    sharingDesign: {
      title: 'QR-Code Design',
      shortTitle: 'QR-Code Design',
      qrcode: {
        tab: 'QR-Code',
        title: 'QR-Code Design',
        chooseColor: 'Choose QR Color',
        preview: 'Preview',
        infoText: 'QR-Code design is applied everywhere, except for the QR-Code in the Wallet.',
      },
      wallet: {
        tab: 'Wallet',
        title: 'Wallet Design',
        onlyApple: 'The following settings apply to Apple Wallet only.',
        showUnitLabel: {
          title: 'Show Unit Label',
          tooltipText:
            'Decide, whether to show the unit label inside of the wallet instead of the company name for unit members.',
        },
        showRoundProfilePicture: {
          title: 'Show Round Profile Picture',
          tooltipText:
            'Decide, whether to show the profile picture in a round shape inside of the wallet.',
        },
        hideLogo: {
          title: 'Hide Logo',
          tooltipText: 'Decide, whether to hide the company logo inside of the wallet.',
        },
        showAcademicDegree: {
          title: 'Show Academic Degree',
          tooltipText: 'Decide, whether to show the academic degree on top of the name.',
        },
        showDepartment: {
          title: 'Show Department',
          tooltipText: 'Decide, whether to show the department next to the position.',
        },
        hideProfileImage: {
          title: 'Hide Profile Image',
          tooltipText: 'Decide, whether to hide the profile image inside of the wallet.',
        },
        background: {
          title: 'Background Image',
          tooltipText: 'Decide, whether to show a background image inside of the wallet.',
        },
        colors: {
          backgroundColor: {
            title: 'Background Color',
          },
          foregroundColor: {
            title: 'Text Color',
            tooltip: 'Only applied to Apple Wallet',
          },
          labelColor: {
            title: 'Label Color',
            tooltip: 'Only applied to Apple Wallet',
          },
        },
      },
      qrbg: {
        chooseImages: 'Choose Images',
        defaultImage: 'Default Image',
        additionalImages: 'Additional Images',
        mobile: {
          tab: 'Phone Background',
          title: 'Mobile background settings',
          helperText:
            'Any vertical format is allowed with a minimum width of 500px. We recommend the format of the most common phone among your team.',
        },
        videocall: {
          tab: 'Video Background',
          title: 'Video background settings',
          helperText:
            'Any horizontal format is allowed with a minimum width of 800px. We recommend the format for virtual backgrounds of the video call tool you use.',
        },
        dialogText: 'Are you sure you want to reset all images?\n\nThis is irreversible!',
        uploadSubtext: 'SVG, PNG, JPG or GIF (any format, minimum width: {{limit}}px)',
      },
    },
    accountGuides: {
      headerPage: 'Let’s start using your Lemontaps profile',
      subHeader:
        'On this page you’ll find an overview of guidelines to start using Lemontaps and getting the most out of it.',
      guidesHeader: 'Step-by-step descriptions to click through',
      videoGuides: {
        header: 'First Steps',
      },
      openQuestions: {
        header: 'Open questions?',
        takeALook: 'Take a look at the FAQ',
        takeALookLink: 'To our knowledge base',
        writeToSupport: 'Write to our support team.',
        writeToSupportLink: 'Create support ticket',
      },
    },
    mdAnalytics: {
      title: 'Analytics',
      profileSavings: 'The result are the following savings',
      networking: {
        title: 'Profile activity',
        subtitle: 'Take a look at how your team is using their cards.',
        shares: 'Profile Shares',
        vcards: 'vCards saved',
        contacts: 'Contacts Collected',
        edits: 'Profile Edits',
        links: 'Total Link Clicks',
        files: 'Total File Clicks',
      },
      tooltips: {
        shares: 'Amount of times your company profiles have been viewed.',
        contacts: 'Amount of contacts collected by all your company accounts.',
        vcards:
          'How many times the "Save Contact" button has been clicked on all your company profiles.',
        links: 'Total number of times some visitor opened a link across all your company profiles.',
        files: 'Total number of times some visitor opened a file across all your company profiles.',
        cards:
          "Number of paper business cards saved by sharing your company's profiles digitally or collecting a digital contact.",
        flyers:
          'Number of physical pages of paper saved by using a digital version instead of a paper printout (e.g., PDF files instead of paper flyers).',
        edits:
          'Every change to a profile of your team (contact information, images, files or links) counts as a profile edit. A maximum of one edit is counted per 7-day period.',
      },
      saves: {
        title: '🌱 Your company is a sustainable leader, you now saved:',
        cards: 'Paper Cards',
        flyers: 'Pages Of Flyers',
        subtitle: '... which means you saved:',
        wood: '🪵 Wood',
        water: '💧 Water',
        energy: '🔋 Energy',
        co2: '☁️ CO2',
      },
    },
    filesTab: {
      header: 'File templates',
      headerTooltip:
        'Define files here, that you can later choose from when adding files to your employees’ profiles.',
      fileName: 'Title',
      fileNamePlaceHolder: 'e.g. One-Pager',
      uploadImage: 'Upload Image',
      errorUploadingFile: 'Error when uploading file',
      successfullySaved: 'File successfully saved',
      successfullyDeleted: 'File successfully Deleted',
      writingDataError: 'Error while saving file',
      selectFileTitle: 'Select a file template',
      searchInputPlaceHolder: 'Search file templates',
      noTemplates: 'No file templates available',
      createTemplate: 'Create file template now',
      orAddIndividualFile: 'or add an individual file:',
      savingFile: 'Saving file',
      savingChanges: 'Saving changes',
      deletingFile: 'Deleting file',
      deleteFile: 'Delete File',
      yesDelete: 'Yes, delete',
      confirmDelete: 'Are you sure you want to delete this file?',
      uploadFile: 'Upload File',
    },
    addressesTab: {
      header: 'Default addresses',
      headerTooltip:
        'Define addresses here, that you can later choose from when adding addresses to your employees’ profiles.',
      addAddresses: 'Add Address',
      addNewAddress: 'Add a new address',
      name: 'Name',
      address: 'Street and House Nr',
      postCode: 'Zip code',
      makeAddressDefault: 'Make this the default address?',
      addressDefaulTooltip:
        'Newly added profiles will have this address assigned to them by default.',
      default: 'Default',
      confirmDelete: 'Are you sure you want to delete address?',
      ErrorDeletingAddress: 'Error while deleting address',
      cannotDeleteDefaultAddress: 'You cannot delete default address.',
      errorReadAddress: 'Unable to load addresses',
      errorWriteAddress: 'At least one address field required!',
      errorWriteLabel: 'The address must have a name!',
      saveSuccess: 'Successfully saved',
      noAddresses: 'No addresses added yet',
      emptyAddressFieldsError: 'Please fill in at least one field',
    },
    qrBgTab: {
      defaultBackgrounds: 'Default Backgrounds',
      defaultMobileBg: 'Default image for QR mobile lock screen:',
      defaultVideoCallBg: 'Default image for QR video call background:',
      minBgSize: 'Image width: at least {{x}}px',
      uploadBg: 'Upload image',
      additionalBgImgs: 'Additional Background Images',
      additionalBgImgsDescription: 'Upload further images that users can choose from',
      additionalMobileBgs: 'More mobile wallpapers:',
      additionalVideoCallBgs: 'More videocall wallpapers:',
    },

    linkTab: {
      header: 'Link Templates',
      headerTooltip:
        'Define links here, that you can later choose from when adding links to your employees’ profiles.',
      addLink: 'Add ',
      addNewLink: 'Add a new Link',
      name: 'Title',
      linkType: 'Link Type',
      linkName: 'Link Name',
      linkUrl: 'URL',
      linkPhone: 'Phone number',
      placeHolderUrl: 'e.g. www.website.com',
      placeHolderLink: 'e.g. Our Website',
      placeHolderPhone: 'e.g. 49 170 12345',
      searchStandardLinks: 'Search link templates',
      noTemplates: 'No link templates available',
      createTemplate: 'Create link template now',
      deleteLink: 'Delete Link',
      confirmDelete: 'Are you sure you want to delete link?',
      yesDelete: 'Yes, delete',
      successAdd: 'Added',
      successEdit: 'Updated',
      errorAdd: 'Error',
      errorEdit: 'Error',
      successDelete: 'Deleted',
      errorDelete: 'Error',
      orAddIndividualLink: 'or add an individual link:',
    },
    rename: 'Rename',
    locationSelector: {
      header: 'Select from standard addresses',
      max2Label: '(a maximum of 2 addresses can be added)',
      orCreateIndividual: 'or create an individual address',
      searchAddress: 'Search address',
      noTemplates: 'No address template available',
      createTemplate: 'Create address template now',
    },
    employeeType: {
      role: 'Role in company',
      employee: 'Employee',
      themeAdmin: 'Administrator',
      unitAdmin: 'Unit-Admin',
      edit: 'edit',
      sendInviteText:
        'When saving, automatically send an invite email to the new address? You can do this later manually as well.',
      profile: 'Profile',
      account: 'Account',
    },

    errorSharingData: 'Error sharing data',
    errorLoad: 'Error while loading contacts',
    errorLoadMore: 'Error while loading more contacts',
    downloading: 'Downloading',
    successfullyDownloaded: 'Successfully downloaded',
    errorWhenDownloading: 'Error while downloading',
    // MD Customization strings end

    //How To Tap Strings Start//
    HowToTap: 'How to tap',
    HowToTapDescription: 'Choose the device you are sharing to',
    important: 'Important!',
    BackupDescriptionHeading: 'You always have a Backup',

    TapNewIphoneHeading: 'Tap to new iPhones',
    TapNewIphoneSubHeading: 'iPhone XR and newer',
    TapNewIphoneDetailHeading: 'Tap to Newer iPhones',
    TapNewIphoneDetailSubHeading: 'iPhone XR, XS, 11, 12, 13',
    TapNewIphoneDetailDescription:
      'To share to newer iPhones, slide and hold your Lemontaps card near the very top of the iPhone until a push notification appears.',
    TapNewIphoneDetailImportantDescription:
      'Their screen must be on, their airplane mode must be off, and their camera must not be open.',
    TapNewIphoneDetailBackupDescription:
      'The tapping requires some training and eventually it will happen that it doesn’t tap right away. Don’t worry, because you can always use the QR-Code.',

    TapOlderIphoneHeading: 'Tap to older iPhones',
    TapOlderIphoneSubHeading: 'iPhone X and older',
    TapOlderIphoneDetailHeading: 'Tap to older iPhones',
    TapOlderIphoneDetailSubHeading: 'iPhone 6, 7, 8, X',
    TapOlderIphoneDetailDescription:
      'To share to older iPhones, the receiver needs to press on the NFC widget in their control center. Then slide and hold your Lemontaps card near the very top of the iPhone.',
    TapOlderIphoneDetailImportantDescription:
      'Sometimes the NFC widget has to be activated in the settings to appear in the control center. Furthermore their screen must be on, their airplane mode must be off, and their camera must not be open.',
    TapOlderIphoneDetailBackupDescription:
      'The tapping requires some training and eventually it will happen that it doesn’t tap right away. Don’t worry, because you can always use the QR-Code.',

    TapAndroidHeading: 'Tap to Androids',
    TapAndroidSubHeading: 'Must have NFC on',
    TapAndroidDetailHeading: 'Tap to Androids',
    TapAndroidDetailSubHeading: 'Every Android with NFC (almost all)',
    TapAndroidDetailDescription:
      'To share to Androids, slide your Lemontaps card around the center back area of their phone. Every Android has a slightly different spot for their NFC reader.',
    TapAndroidDetailImportantDescription:
      'Ask if their NFC is turned on. To turn on the NFC pull down the Quick Settings Menu and press on the NFC button.',
    TapAndroidDetailImportantDescription2:
      'Sometimes you need to search ‘NFC’ in the phone settings. ',
    TapAndroidDetailBackupDescription:
      'The tapping requires some training and eventually it will happen that it doesn’t tap right away. Don’t worry, because you can always use the QR-Code.',

    TapScanHeading: 'Scan QR-Code',
    TapScanSubHeading: 'All Phones',
    TapScanDetailHeading: 'Scan QR-Code',
    TapScanDetailSubHeading: 'All iPhones and Android Phones',
    TapScanDetailDescription:
      'You can find your QR-Code in the Lemontaps Home Dashboard or printed on your card. Most devices can simply scan the QR-Code with their normal camera.',
    TapScanDetailImportantDescription:
      'You can create your phone lockscreen and videocall background with your QR-Code to share your Lemontaps business card even faster.',

    // How to Tap Strings End //
    contactShareFile: '_Profile',
    contactShareTitle: 'Contact ',
    contactShareText: 'Digital Contact from ',
    leaveYourContact: 'Leave me your contact',
    submit: 'Submit',
    profileForwardNotice: 'Note: Your profile is currently forwarded to {{url}}',
    downloadContactFile: 'Download Contact File',
    redirectionActivated: 'Redirection active',
    vcardDownloadEnabled: 'Automatic vCard-Download activated',
    updateProfile: {
      autoVCardDownload: {
        title: 'Automatically trigger vCard download',
        helperText:
          'Set up your profile so that the vCard is downloaded automatically. On desktop and Android, the profile will open and the file downloads automatically. On iPhone, the contact will open automatically and can be added to the address book.',
      },
    },
    md: {
      requestNow: 'Request now',
      requestNowBullets: ['No credit card or cancellation necessary.', 'No installation required.'],
      profiles: {
        roleUpdated: 'Role updated',
        roleUpdateError: 'Error updating role',
        sidebar: {
          tabs: {
            tooltipProfile: 'Edit profile information such as name, phone numbers, addresses, etc.',
            tooltipAccount: 'Edit the login email and role',
            tooltipCards: 'Add or remove cards to/from this profile',
          },
        },
        error: {
          deleteMainAccount: 'You cannot delete the team owner.',
        },
        resetPasswordDialogTitle: 'Do you want to proceed?',
        resetPasswordDialogBody:
          'An email will be sent to the selected user with steps to reset their password.',
        resetPasswordSuccess: 'Password-Reset email sent successfully',
        resetPasswordError: 'Error sending password-reset email',
      },
      bioFieldsConfigurator: {
        title: 'Contact Attributes ',
        description:
          'Hide attributes on the digital business card, on the end-user edit page, delete, rename, change their order, or add drop-down templates for selected fields',
        internalFields: 'Internal Fields (never rendered on business cards)',
        addAttribute: 'Add Attribute',
        addAttributeDescription: 'Add a new attribute to the profile',
        renameField: 'Rename "{{field}}" Attribute',
        selectAttribute: 'Select',
        nonEditableButtonTooltip: 'Hide/show attribute on user edit page',
        visibilityButtonTooltip: 'Hide/show attribute on digital business card',
        deleteButtonTooltip:
          'Remove attribute from edit views and business card (can be re-added anytime)',
        editButtonTooltip: 'Edit attribute',
        fieldOptions: 'Attribute Options',
        fieldOptionsSubtitle:
          "If you'd like to translate the options, head to the Translation Settings under",
        translations: 'Translations',
        addDropdownOptions: 'Add Dropdown Options',
        allowCustomText: 'Allow custom values',
        dropdownSettings: 'Dropdown Settings',
        addOption: 'Add Option',
        deleteMessage: 'Are you sure you want to delete this attribute?',
        phoneNumberFormattingSettings: {
          header: 'Phone Number Formatting',
          includeCountryCode: 'Include country code',
          mode: {
            manual: 'Manual',
            rule: 'Own Rule',
            auto: 'Auto',
          },
          manualOptions: {
            digits: '# Digits Block',
            digitsLabel: '#digits',
            separator: 'Separator Block',
            separatorLabel: 'separator',
            rest: 'Rest',
            restLabel: 'rest',
            countryCodeLabel: 'Country Code',
            areaCode: 'Area Code',
            areaCodeLabel: 'area code',
          },
          separator: {
            space: '[ ] Space',
            dot: '[.] Dot',
            hyphen: '[-] Hyphen',
            slash: '[/] Slash',
          },
          includeCountryCodeWarning:
            'Automatic formatting is not possible on phone numbers without country codes.',
          ruleNotApplicableWarning:
            'If a number has too few or too many digits and the rule cannot be applied, the number will be displayed unformatted.',
        },
        groups: {
          headerFields: 'Header Fields',
          contactDetailsBoxFields: 'Contact Details Box Fields',
          customBioTextBoxFields: 'Custom Bio Text Box Fields',
          otherFields: 'Other Fields',
        },
      },
      vcardConfigurator: {
        title: 'vCard Configurator',
        description:
          'The vCard is the contact file that is downloaded when clicking on “Save contact” or when sharing the offline QR-Code. You can edit some of the settings here.',
        contactInfoTitle: 'Contact Info Configuration',
        contactInfoDescription:
          'Decide whether to hide certain fields in the vcard or to change the label of the attribute. Keep in mind that on some phones (especially Androids) the custom label will not be shown. They are instead replaced with default labels such as “Other”.',
        chooseLabel: 'Choose Label',
        createLabel: 'Create Label',
        editLabel: 'Edit Label',
        createCustomLabel: 'Create a custom label',
        customLabel: 'Label',
        customLabelInfo: 'Type any custom label or choose from the presets.',
        notes: 'Notes',
        notesGerman: 'Notes (German)',
        notesEnglish: 'Notes (English)',
        notesTooltip:
          'Configure a custom text that will be included in the "notes" section of the downloaded contact. You can use "{{currentDate}} as a variable which will be replaced with the current date when the vcard is downloaded. You can also use "{{profileLink}} for the profile link.',
        additionalSettings: 'Additional Settings',
        showLinks: 'Show all profile links',
        showLinksTooltip: 'Include profile links in the downloaded contact.',
        showLinksOffline: 'Also show all profile links in offline QR-Code',
        showLinksOfflineTooltip:
          'Only recommended when you have a small amount of links. Otherwise, the QR-Code will be difficult to read.',
        convertSpecialChars: 'Convert special characters in vCard',
        convertSpecialCharsTooltip:
          'Replace special characters like ä, ö, ü with ae, oe, ue, since some Outlook versions may not be able to interpret those.',
        samelLabelOutlookWarning:
          'To achieve maximum compatibility, attributes of the same type (e-mails, phone numbers, addresses) should have different names, as this can lead to incorrect imports, particularly with Outlook.',
        sameLabelEmailWarning:
          '{{fields}} have the same label or both have custom labels. The import into outlook might fail!',
        sameLabelAddressWarning:
          '{{fields}} have the same label or both have custom labels. When importing the vCard into Outlook, only one of the addresses might be displayed!',
        sameLabelLinkWarning:
          '{{fields}} have the same label or both have custom labels. When importing the vCard into Outlook, only one of the links might be displayed!',
        show: 'Show "{{field}}" field in vcard',
        doNotShow: 'Do not show "{{field}}" field in vcard',
      },
      defaultContent: {
        noFiles: 'No default files configured for the selected unit',
        noLinks: 'No default links configured for the selected unit',
        noAddresses: 'No default addresses configured for the selected unit',
        noBioContent: 'No default profile attributes configured for the selected unit',
        defaultLink: 'Default Link',
        defaultLinks: 'Default Links',
        defaultFile: 'Default File',
        defaultFiles: 'Default Files',
        description:
          'You can add default addresses, links and files that are going to be shown on every profile. When information changes, just update the content here and the update will be applied on all profiles',
        errorLoadingFiles: 'Error loading default files',
        successSaveFile: 'File saved successfully',
        errorSavingFile: 'Error saving file',
        successDeleteFile: 'File deleted successfully',
        errorDeleteFile: 'Error deleting file',
        errorLoadingLinks: 'Error loading default links',
        successSaveLink: 'Link saved successfully',
        errorSavingLink: 'Error saving link',
        successDeleteLink: 'Link deleted successfully',
        errorDeleteLink: 'Error deleting link',

        addAddress: 'Add default address',
        editAddress: 'Edit default address',
        defaultAddresses: 'Default Addresses',
        errorLoadingAddress: 'Error loading address',
        successSaveAddress: 'Address saved successfully',
        errorSavingAddress: 'Error saving address',
        successDeleteAddress: 'Address deleted successfully',
        errorDeleteAddress: 'Error deleting address',

        addBioContent: 'Add default profile attribute',
        editBioContent: 'Edit default profile attribute',
        defaultBioContent: 'Default profile attributes',
        defaultBioContentTooltip:
          'The values configured here will be shown on all profiles, disregarding any previous profile-level configuration.',
        selectAttribute: 'Select attribute',
        setDefaultContent: 'Set default content',
        errorLoadingDefaultBioContent: 'Error loading default profile attributes',
        successUpdateBioContent: 'Default profile attribute updated successfully',
        errorUpdateBioContent: 'Error updating profile attributes',
        deleteBioContentConfirm: 'Are you sure you want to delete the default profile attribute?',
        defaultBioContentAlert:
          'After you delete a default profile attribute, values that were created before the configuration of the default value may reappear in the profiles. To clear the field for all profiles, go to the profile table, select all profiles, and then click on "Bulk-Edit".',
        setupSettings: {
          links: {
            title: "Currently this unit's default links are in sync with the organization settings",
            description:
              "You can set different default links for this unit, but they won't be in sync with the organization settings anymore.",
            buttonText: 'Set different default links for this unit',
          },
          files: {
            title: "Currently this unit's default files are in sync with the organization settings",
            description:
              "You can set different default files for this unit, but they won't be in sync with the organization settings anymore.",
            buttonText: 'Set different default files for this unit',
          },
          addresses: {
            title:
              "Currently this unit's default addresses are in sync with the organization settings",
            description:
              "You can set different default addresses for this unit, but they won't be in sync with the organization settings anymore.",
            buttonText: 'Set different default addresses for this unit',
          },
          bioContent: {
            title:
              "Currently this unit's default profile attributes are in sync with the organization settings",
            description:
              "You can set different default profile attributes for this unit, but they won't be in sync with the organization settings anymore.",
            buttonText: 'Set different default profile attributes for this unit',
          },
        },
      },
      contentTemplate: {
        linkTemplates: 'Link Templates',
        fileTemplates: 'File Templates',
        addressTemplates: 'Address Templates',
        description:
          'Create Content Templates for Addresses, Links and Files that you as an admin can choose from when editing profiles. When you update the template all profiles that are using that template will have that update. ',

        errorLoadingFiles: 'Error loading file templates',
        successSaveFile: 'File template saved successfully',
        errorSavingFile: 'Error saving file template',
        successDeleteFile: 'File template deleted successfully',
        errorDeleteFile: 'Error deleting file template',

        errorLoadingLink: 'Error loading link templates',
        successSaveLink: 'Link template saved successfully',
        errorSavingLink: 'Error saving link template',
        successDeleteLink: 'Link template deleted successfully',
        errorDeleteLink: 'Error deleting link template',

        errorLoadingAddress: 'Error loading address templates',
        successSaveAddress: 'Address template saved successfully',
        errorSavingAddress: 'Error saving address template',
        successDeleteAddress: 'Address template deleted successfully',
        errorDeleteAddress: 'Error deleting address template',
      },
      profileDesign: {
        customCss: {
          label: 'Custom CSS',
          tooltip: 'Add custom CSS to change the profile design.',
          customCssClasses: 'Choose CSS classes',
        },
        previewTooltip: 'Save your changes first and then click on preview',
        freeToChoose: 'Current setting: Employees can freely choose their banner images',
        boxFormTooltip: 'Determines the appearance of all box-shaped elements in the profiles.',
        uploadImageTooltip:
          'If no images are uploaded, employees are free to choose their cover image. When uploading one or more images, your employees will see a selection of these images, from which they must choose one. In the latter case no images can be uploaded freely.',
        buttonColorSaveContactTooltip:
          'Background color of the "Save Contact" and the "Submit" button of the contact submission form.',
        buttonColorFilesTooltip: 'Background color of the file buttons.',
        buttonColorGenericWebsitePicker: 'Background color of the generic website buttons.',
        coverImageTooltip:
          'Determines the default cover image when no individual cover image is uploaded for the user. You can also decide not to show any cover image. When updating the default cover image only the profiles without an individual cover image will be updated.',
        faviconImageTooltip: 'Determines the default favicon.',
        profileImageTooltip:
          'Determines the default avatar when no individual profile image is uploaded for the user. You can also decide not to show any avatar. When updating the avatar only the profiles without an individual profile image will be updated.',
        logoImageTooltip:
          'While empty, users can upload their own custom image as a logo to their profile. When this option is set, then users will not be able to upload their own image as a logo.',
        faviconTitle: 'Custom Favicon',
        useCustomFavicon: {
          title: 'Use custom favicon',
          tooltip: 'Use a custom favicon. Will be rendered in the browser tab.',
        },
        defaultFavicon: 'Default Favicon',
        showForm:
          'If you disable this feature, the contact form will no longer be displayed in your digital business card profile.',
        showFormAsPopup:
          'If you enable this feature, then upon opening your digital business card profile, the contact form will be displayed directly in the form of a popup. This feature is useful at events to quickly and easily capture the contact information of the other person.',
        themeLinks: {
          tooltip: `The default links will be displayed on every employees' profile. They are not able to edit or delete them.`,
          title: 'Position Default Links',
        },
        themeLinksPosition: {
          before: 'Before individual links',
          after: 'After individual links',
          question: 'Where to display the default links?',
        },
        themeFiles: {
          tooltip: `The default files will be displayed on every employees' profile. They are not able to edit or delete them.`,
          title: 'Position Default Files',
        },
        themeFilesPosition: {
          before: 'Before individual files',
          after: 'After individual files',
          question: 'Where to display the default files?',
        },
        themeAddresses: {
          tooltip: `The default addresses will be displayed on every employees' profile. They are not able to edit or delete them.`,
          title: 'Position Default Addresses',
          settingHasMoved:
            'The setting has moved to the "Contact Attributes" section. Please update your settings there.',
        },

        linksTooltip: 'You can set up link templates via settings -> global company data',
        filesTooltip: 'You can set up file templates via settings -> global company data',
        additionalLogosTitle: 'Additional Logos',
        additionalLogosTooltip:
          'If no images are uploaded, employees are free to choose their logo. When uploading one or more images, your employees will see a selection of these images, from which they must choose one. In the latter case no images can be uploaded freely.',
        additionalLogosDescription: 'Upload logos that the employees must choose from',
        additionalLogosUploadButton: 'Upload Logo',
        additionalLogosUploadFurtherButton: 'Upload further Logo',
        additionalLogosCurrentSettings: 'Current setting: Employees can freely choose their logo',
        additionalLogosDefaultLogoIsSet:
          'Current Setting: A global logo is defined that is displayed on every profile. Remove the default logo set above so you can upload multiple logos here.',
        moreSettings: 'More Settings',
        nameSuffixConnector: 'Name Suffix Connector',
        nameSuffixConnectorTooltip:
          'How will the name suffix be connected to the name? E.g. it may be separated by a comma.',
        autoVCardDownload: {
          title: 'Automatically trigger vCard download',
          tooltip:
            'When opening the profile, the vCard will be downloaded automatically. On desktop and Android, the profile will open and the file downloads automatically. On iPhone, the contact will open automatically and can be added to the address book.',
          alertDescription: 'All profiles trigger an automatic vCard download.',
          goToSetting: 'Go to Settings',
        },
        showLeftBorder: {
          title: 'Show dotted border',
          tooltip: 'If active, a dotted line will be shown to the left of the name',
        },
        fonts: {
          useCustomFont: 'Use custom font',
          familyName: 'Font Family Name',
          fileUploadDescription:
            'Upload the respective font files for the following variants. We only require {{requiredVariants}} but you can decide to upload more variants as this might change in the future.',
          variants: {
            normal: {
              300: 'Normal 300',
              400: 'Normal 400',
              500: 'Normal 500',
              600: 'Normal 600',
              700: 'Normal 700',
              800: 'Normal 800',
            },
            italic: {
              300: 'Italic 300',
              400: 'Italic 400',
              500: 'Italic 500',
              600: 'Italic 600',
              700: 'Italic 700',
              800: 'Italic 800',
            },
          },
          warnings: {
            preferredFormatsNotDefined: 'Neither WOFF nor WOFF2 format defined',
            preferredFormatsNotDefinedDetails:
              'For the best browser and device compatibility, it is recommended to define at least one of the two formats.',
            invalidFontFile: 'Invalid file format',
          },
          googleFontInfo:
            'This font is a Google Font. When selecting this font, Google servers are referenced. Please not that you may have to append your data privacy policy to account for this.',
          adobeFontInfo:
            'This font is an Adobe Font. When selecting this font, Adobe servers are referenced. Please not that you may have to append your data privacy policy to account for this.',
          manualFontInfo: 'To change the font, please contact us at support@lemontaps.com',
        },
      },
      customizationFooter: {
        mainTooltip:
          'The information saved here will be displayed in the footer of the public profile.',
      },
      editEmployee: {
        settings: 'Profile settings',
        autoVCardDownload: {
          title: 'Automatically trigger vCard download',
          helperText:
            'When opening the profile, the vCard will be downloaded automatically. On desktop and Android, the profile will open and the file downloads automatically. On iPhone, the contact will open automatically and can be added to the address book.',
          alertDescription:
            'When opening the profile, a vCard download is automatically triggered. To disable this feature, open the profile settings.',
          alertDescriptionEnabledGlobally:
            'When opening the profile, a vCard download is automatically triggered. This setting is globally enabled. To disable it, open the profile design settings.',
        },
      },
    },
    preview: 'Preview',
    home: 'Home',
    profile: 'Profile',
    contacts: 'Contacts',
    mdCards: {
      title: 'Cards',
      upgradeToContinue:
        'Unfortunately, you cannot select this action during the trial period. Please upgrade to continue.',
      noBoxThemeAdmin: 'Contact us to enable options to order NFC-cards from this page.',
      noBoxUnitAdmin:
        'Your administrator has disabled the option to reorder nfc-cards from this page.',
      order: {
        title: 'Order NFC-Cards',
        imageAlt: 'Depiction of physical NFC-Cards',
        body: 'Order free sample cards , reorder cards with your last design or order cards with a new design.',
        actionLabel: 'Order NFC-Cards',
        subaction: {
          sampleCards: {
            label: 'Order Sample Cards',
            tooltip:
              'They are free to order and come with a sample design. The cards have to be sent back after testing.',
          },
          firstTimeOrder: {
            label: 'Order Cards with new design',
            tooltip: 'If you design should change or you order cards for the first time.',
          },
          reorder: {
            label: 'Reorder Cards with same design',
            tooltip:
              'If you have already ordered cards before, we have your design ready and all you need to do is to fill out an order form.',
          },
        },
        byCountryPopup: {
          title: 'Delivery Country',
          other: 'Other country? Please contact support@lemontaps.com',
        },
      },
      paperCardsBox: {
        title: 'Paper Business Card Ordering System',
        description:
          'Manage the administrative settings of the paper business card ordering system, such as approval processes. You can also order new paper business cards for your employees.',
        teaserDescription:
          "If you don't want to fully switch to digital business cards, you can add the paper business card ordering system with which you can easily create the print files and send them to your printing service automatically.",
        imageAlt: 'A paper business card',
        buttonText: 'Manage Paper Business Cards',
        actions: {
          approval: 'Go to Release System',
          order: 'Place order for employees',
          buyAddon: 'Buy Addon',
        },
      },
    },
    nfcSample: {
      title: 'Order Sample Cards',
      subtitle:
        'Try out our NFC cards. You can order the sample cards for free if you return them.',
    },
    nfcFirstOrder: {
      title: 'Order cards for the first time',
      subtitle:
        'As a Teams user, you have access to discounted card prices. Design the cards to match your corporate design.',
    },
    nfcReorder: {
      title: 'Reorder cards with last design',
      subtitle:
        'Here you have the option to easily reorder more cards with the same design as your last order.',
    },
    settings: {
      main: 'Account Settings',
      more: 'More',
      managementPlatform: 'Management Platform',
      changePassword: 'Change Password',
      changeEmail: 'Change login email',
      help: 'Help & Support',
      helpCaption: 'Help Center, Academy, Support',
      openCookieSettings: 'Change Cookie Settings',
      openShopSettings: 'Go to our shop',
      openPaperCardForm: 'Order paper business card',
      mycards: 'Manage cards',
      changeLanguage: 'Change Account Language',
      selectLanguage: 'Select Language',
      paperCardOrder: 'Print version',
      paperCardOrderCaption: 'Order paper business cards',
    },
    moreSettings: {
      title: 'More',
      teamMangement: 'Team Management',
      teamMangementCaption: "Manage your team's business cards",
      analytics: 'Analytics',
      analyticsCaption: 'Profile & sustainability insights',
      addApp: 'Add App',
      addAppCaption: 'Add the application to your phone',
      accountSettings: 'Account Settings',
      accountSettingsCaption: 'Change email, password ...',
      nfcCards: 'NFC-Cards',
      nfcCardsCaption: 'Activate, manage and order',
      printCard: 'Print Version',
      printCardCaption: 'Order new paper business cards',
      signOut: 'Sign Out',
    },
    changeEmail: {
      title: 'Change login email',
      currentEmail: 'Current email address',
      newEmail: 'New email address',
      notAllowed: {
        title: `Email cannot be changed`,
        text: `You are authenticated via {{idp}}, therefore you cannot change your email here. If you need another email, please delete your account and sign up again or contact an administrator.`,
      },
      error: {
        invalidFormat: 'Enter a valid email',
        unchanged: 'Enter a new email',
      },
    },
    homePage: {
      toAcademy: 'To Academy',
      hello: 'Hello',
      digitalBusinessCard: 'Your digital business card',
      shareProfile: {
        title: 'Share Profile',
        copyToShare: 'Copy to share',
        actionTitle: 'View all sharing options',
        via: 'via Link, QR-Code, Wallet...',
      },
      addAppToPhone: {
        title: 'Download App',
        popupTitle: 'Download the Lemontaps App',
        description:
          'Either search for "Lemontaps" in the App Store/Google Play Store or scan the QR-Code:',
      },
      nfcCard: {
        addAndManage: 'NFC-Cards',
        title: 'NFC Card',
        allAboutNFC: 'Everything about the NFC card',
        manageCards: 'Manage Cards',
        manageCardsSub: 'Link new cards or remove them.',
        instruction: 'Instruction',
        instructionSub: 'Learn the best practices on how to "tap" the card with different phones.',
        buyNew: 'Buy New Cards',
        buyNewSub: 'Customize the card with your design. Available in bamboo, metal and plastic.',
        multiTitle: 'Discover our NFC cards',
        multiText:
          'Customize the cards with your design. Available in bamboo, recycled plastic and metal.',
        btnText: 'To the shop',
      },
      leads: {
        recentContacts: 'Recent Contacts',
        title: 'Capture leads',
        manage: 'To the contact management',
        previewForm: 'View lead form on my profile',
      },
      analytics: {
        title: 'Analytics',
        profileViews: 'Total Profile Views',
        leadsCollected: 'Total Leads Collected',
      },
      academy: {
        title: 'First steps & Academy',
        popupTitle: 'Lemontaps Academy is not available in your current plan',
        popupText:
          'Lemontaps Academy is a collection of introductory and best practice videos, such as how to use Lemontaps at fairs or in 1 on 1 meetings.\nThis feature is an Addon and not available in your current plan.',
      },
      support: {
        title: 'Your contact person',
        admin: 'Your Admin',
        lemontapsSupport: 'Lemontaps Support Team',
      },
      quickActions: {
        title: 'More Quick Actions',
        getApp: 'Get App',
        nfcCards: 'NFC Cards',
        analytics: 'Analytics',
        scanCard: 'Scan Card',
      },
      viewAll: 'View all',
      learnMore: 'Learn more',
      ////not translated DE
      addLemontapsAsAnApp: 'Add Lemontaps as an homescreen app',
      addAppToHomescreen:
        'Add it as an app to your homescreen. This way you can always easily access your profile and account.',
      exampleForIphone: 'Example for Iphone (similar to Android):',
      gotIt: 'Got it!',
      ////
      shareProfilePer: 'Share profile via...',
      addQrWallpaper: 'Create QR-Wallpaper',
      qrCodeWallpaper: 'QR-Code Background',
      subTitle: 'Explore the different options on how your can use your Lemontaps profile: ',
      qrTitle: 'QR-Wallpaper ',
      qrText: 'Link your Lemontaps Profile to your phone and videocall background.',
      qrBtnText: 'Create Background ',
      shareLink: 'Share Link',
      shareYourLink: 'Share your link',
      tip: '💡Tip:',
      tipText: 'Copy and paste the link into your email signature:',
      qrCode: 'QR-Code',
      profileViews: 'Analytics',
      overviewProfileViews: 'Profile views overview',
      total: 'Total: ',
      thisWeek: 'This week:',
      howToTap: 'How to Tap?',
      help: 'Help',
      desktopSubTxt: 'Discover different ways you can use your Lemontaps profile:',
      copyLink: 'Copy profile link',
    },
    leadGen: {
      sendFollowUpEmail: 'Send follow-up email',
      followUpEmailSent: 'Follow-up email sent successfully',
      followUpEmailError: 'Failed to send follow-up email',
      followUpEmailErrorNoEmail: 'The contact has no email address',
      upgradeTitle: 'Upgrade Now!',
      upgradeText: 'Upgrade Now to be able to see all your collected contacts!',
      upgradeBtnText: 'Get the Upgrade',
      upgradeBtnClickedText: 'Request sent',
      noLeads: 'No contacts collected so far.',
      infoFromProfile: 'Information from Profile',
      infoFromContact: 'Information from Contact',
      lt2ltNotFound: 'Oops! Profile not found 🙈',
      uploadNew: 'Upload new',
      businessCardTitle: 'Physical Business Card',
      businessCardSubtitle: 'Upload an image of a paper business card',
      newFeatureEnrichment: {
        title: '🚀 New Beta Feature: Badge & LinkedIn Scanner + Enrichment',
        text1: 'Try our automated contact enrichment tool for free now!',
        text2:
          '📌 Note: After the beta phase, this feature will be available as a paid optional add-on.',
      },
      noEnrichmentFoundAlert: {
        title: 'Enrichment unsuccessful',
        body: "For this contact we couldn't find any further information",
      },
      attachments: {
        unsupportedFile: 'Unsupported file type. Supported formats: {{supportedFormats}}',
      },
    },
    showQr: {
      pageTitle: 'QR-Code',
      online: 'online',
      offline: 'offline',
      btnTxt: 'Download QR-Code',
      cardHeadTxt: 'Use Case: ',
      cardDiscTxtOn: 'Use your QR-Code in presentations.',
      cardDiscTxtOf:
        'The offline QR-Code works without internet, but only opens the vCard and not profile.',
      downloadSuccess: 'Download was successful',
      downloadError: 'Please reload the page and try again',
      downloadQrBgsError: 'You first have to set a default image in the settings',
      downloadQrBgsErrorMaxAllowed: 'Only {{max}} profiles can be selected for this action.',
    },
    datePicker: {
      options: {
        title: 'Select time range',
        today: 'Today',
        pastWeek: 'Past week',
        pastMonth: 'Past month',
        past90Days: 'Past 90 days',
        pastYear: 'Past year',
        allTime: 'All time',
      },
      heading: {
        startDate: 'Start Date',
        endDate: 'End Date',
      },
    },
    analytics: {
      options: {
        title: 'Select time range',
        today: 'Today',
        pastWeek: 'Past week',
        pastMonth: 'Past month',
        past90Days: 'Past 90 days',
        pastYear: 'Past year',
        allTime: 'All time',
      },
      saves: {
        title: '🌱 You are a sustainable leader, you now saved:',
        cards: 'Paper Cards',
        flyers: 'Pages Of Flyers',
        subtitle: '... which means you saved:',
        wood: '🪵 Wood',
        water: '💧 Water',
        energy: '🔋 Energy',
        co2: '☁️ CO2',
      },
      networking: {
        title: '{{firstName}}, you are a real networker!',
        titleSmall: 'Your networking stats',
        shares: 'Profile Shares',
        contacts: 'Leads Collected',
        vcards: 'vCard Saved',
        edits: 'Profile Edits',
      },
      clicks: {
        unit_one: '{{count}} Click',
        unit_other: '{{count}} Clicks',
        title: 'Let’s look at the details:',
        links: 'Total Link Clicks',
        files: 'Total File Clicks',
        oldFileClicks: 'Clicks on old Files',
        oldLinkClicks: 'Clicks on old Links',
      },
      tooltips: {
        vcards: 'The "Save contact" button on your profile page has been clicked this many times.',
        edits:
          'Everything you change in your profile (links, files, contact info, etc.) is a profile edit. Per 7-day period a maximum of one edit is counted.',
        contacts: 'You have collected this many contacts.',
        shares: 'You have shared your profile this many times.',
        cards:
          'Number of paper business cards saved by sharing your profile digitally or collecting a digital contact.',
        flyers:
          'Number of physical pages of paper saved by using a digital version instead of a paper printout (e.g., PDF files instead of paper flyers).',
      },
      share: {
        share: 'Share',
        dialogTitle: 'Share your analytics',
        title: 'My sustainable networking stats',
        text: 'My impact using the digital and sustainable business card by Lemontaps:\n\n🎫   I’ve saved {{cards}} paper cards\n📃   I’ve saved {{flyers}} pages of flyers \n🪵   I’ve saved {{wood}}kg wood \n💧   I’ve saved {{water}}l water \n🔌   I’ve saved {{energy}}kWh energy \n🌫️   I’ve saved {{co2}}kg CO2 \n\nJoin the networking revolution and be a digital and sustainable leader! Register now with Lemontaps for free yourself!',
      },
    },
    loginOrRegister: {
      title: 'This card is not connected to any business card profile yet.',
      connectNew: 'Create new profile',
      connectExisting: 'Connect card to existing profile',
      linkAsAdmin: 'Link card as administrator',
    },
    linkCode: {
      noProfilesFound: 'No profiles found',
      searchBy: 'Search by',
      selectProfile: 'Select a profile to connect',
      searchProfile: 'Search profile',
      close: 'Close',
      editDate: 'Last edit date',
      createDate: 'Creation date',
      sortBy: 'Sort by',
      sortOrder: 'Sort order',
      asc: 'Ascending',
      desc: 'Descending',
      filter: 'Filter',
      withoutNFC: 'Without a NFC card connected',
      successLinkTitle:
        'Congratulations, you have successfully connected the selected profile to the NFC-Card.',
      successLinkSubTitle: 'Now open your camera to scan the next NFC-Card.',
      errorLinkTitle: 'An error occurred',
      tryAgain: 'Try again',
      dontShowAgain: 'Don’t show again',
      confirmLinkText: 'Are you sure you want to connect the selected profile to the NFC-Card?',
      connectToNfc: 'Connect to NFC-Card?',
    },
    mainAdminOnboarding: {
      video: {
        title: 'Welcome to the full version of Lemontaps!',
        description:
          'Your Customer Success Team is excited to welcome you! In this brief video, we’ll walk you through the onboarding process.',
        buttonTitle: 'Continue',
        bottomText:
          'Note: This onboarding information is visible only to you as the main admin. Other admins and users will not see it.',
      },
      questions: {
        title: 'Share your use case with us',
        description:
          'This helps your Customer Success Team understand your needs and provide the best support possible.',
        buttonTitle: 'Get Started',
      },
      backToGuides: 'Back to Guides',
    },
    onboarding: {
      howShareProfile: 'That’s how you share your profile',
      howMany: 'How many employees are in your company?',
      howManyPotentialUsers: 'Of those, how many could be using Lemontaps?',
      whyLemontaps: {
        title: 'What is your goal using Lemontaps?',
        personal: 'For personal use',
        company: 'Testing for my company/team',
      },
      viaQR: 'via QR-Code',
      viaNFC: '... or tap via NFC',
      slideVeryTop: 'Slide near the very top:',
      mustPressNFCbutton: 'The receiver must first press the NFC button in the control center:',
      androidGifText1: "Ask if the receiver's NFC is turned on",
      androidGifText2: 'Slide the back of the phone back and forth ',
      turnOnNFC: 'How to turn on NFC',
      lastAdvice: 'Some last advice',
      congratsTitle: 'Congrats! You are ready to start networking now 🎉',
      importForNFC: 'Important for NFC:',
      lastAdviceAboutNFC: {
        pointOne: 'screen must be on',
        pointTwo: 'airplance mode must be off',
        pointThree: 'camere must not be open',
      },
      advice:
        'The Tapping via NFC takes a little practice, but don’t worry if it doesn’t work - you can always let them scan the QR-Code 🤗',
      continue: 'Continue',

      welcome: `Welcome - lets' create your digital business card`,
      addToWallet: {
        title: 'Add QR-Code to your wallet',
        description:
          'To share your digital business card, add the QR-Code to your wallet. We have also sent you your wallet via e-mail.',
        step1: 'Choose your QR-Code type',
      },
      tellUs: 'Tell us about yourself',
      forPersonalize: 'For a personalized Lemontaps experience',

      other: 'Other',
      selectCategory: 'Select a category that best describes you',
      enterOtherCategory: 'Enter other Category',
      howDidYouhear: 'How did you hear about Lemontaps',
      EnterOther: 'Enter other',
      letsStart: `Let's start`,
      useCasePreferenceTitle: 'Which of these products are you interested in?',
      useCasePreference: {
        'sales-assistant': 'Sales Assistant',
        'lead-gen': 'Lead Generation',
        'digital-business-cards': 'Digital Business Cards',
        'two-in-one-business-cards': 'Two-in-One Business Cards (Paper + Digital)',
        'nfc-cards': 'NFC Cards',
        'email-signature': 'Email Signature',
      },
    },
    'sales-manager': 'Sales Manager',
    sales: 'Sales',
    'field-representative': 'Field Representative',
    hr: 'HR',
    procurement: 'Procurement',
    consultant: 'Consultant',
    'c-level': 'C-Level',
    it: 'IT',
    freelancer: 'Freelancer',
    marketing: 'Marketing',
    other: 'Other',
    openCookieSettings: 'Cookie Settings',
    openShopSettings: 'Go to our shop',
    showMore: 'Show more',
    showLess: 'Show less',
    optional: 'optional',
    publicProfile: {
      autoConnect: {
        heading: 'Contact created',
        subheading: 'Add some notes.',
        button: 'View',
      },
      actionsBar: {
        buttonLabel: 'Back To Platform',
      },
      profileForced:
        'When shared, your profile currently forwards to "{{url}}". If you do not want to forward your profile any more, you need to deactivate the flash on the respective link.',
      profileForcedVCard:
        'When opening your profile, the vCard is automatically downloaded. To change this, open the profile settings.',
      profileForcedVCardGlobal:
        'When opening your profile, the vCard is automatically downloaded. This setting has been globally enabled by an admin.',
    },

    shareTo: {
      shareDestination: 'Share to..',
      shareDetails: 'Share your Lemontaps to all your connections so everyone knows about it.',
      shareWhatsapp: 'Share via Whatsapp',
      shareLinkedin: 'Share via Linkedin',
      shareEmail: 'Share via Email',
      shareFacebook: 'Share via Facebook',
      shareTelegram: 'Share via Telegram',
      shareMail: 'Share via Mail',
      shareViaOther: 'Share via other',
      copyAndShare: 'Copy text and share via {{via}}',
      textCopied: 'Text copied successfully!',
      shareProfile: {
        shareYourProfile: 'Share your porfile',
        shareYourProfileDetails:
          'Network and connect better by sharing your Lemontaps profile everywhere. ',
        userText: 'Use lemontaps in',
        qrCode: 'My Lemontaps QR-Code',
        lemonTapsShare: 'Share my Lemontaps to ..',
      },
      presentations: {
        useInPresentations: 'Use in Presentations',
        useInPresentationsDetails:
          'Place your Lemontaps QR-Code in presentations so everyone can connect with you easily.',
      },
    },
    fieldRequired: 'Field required',
    cards: {
      card: 'Karte "{{code}}"',
      connect: 'Connect',
      alert: {
        title: 'Flexible card mangement',
        subtitle:
          'You can connect to and remove cards from your profile at any time. Removed cards can be connected to new profiles.',
      },
      orderCard: 'Order',
      reorderCard: 'Re-Order',
      connectCard: 'Connect Card',
      deletePopup: {
        title: 'Remove Card?',
        description: 'Once the card is removed it can be connected to any profile again.',
      },
      enterCodePopup: {
        title: 'Enter code to connect',
        description:
          'Note: This is only a backup method if the camera doesn’t work. To receive the code please contact support@lemontaps.com.',
      },
      scanCardPopup: {
        title: 'Scan the QR-code on your card',
        description:
          'QR-Code is not recognized??\n\n1. Scan the QR-Code using your normal phone camera app\n2. Backup: Contact support@lemontaps.com and then <0>enter the code manually</0>',
      },
      noCardsViewWithShop:
        'No cards are connected to your profile yet. Connect or order a card by clicking below.',
      noCardsViewWithoutShop:
        'No cards are connected to your profile yet. Connect your first card now.',
      cardsHeader: 'Overview of connected cards',
      loadingCards: 'Loading cards',
      noCards: 'No cards',
      connectANewCard: ' Connect a new card',
      cards: 'Cards',
      remove: 'remove',
      uploadingCode: 'Validating code',
      successUpload: 'Code connected',
      errorUpload:
        'Code could not be connected. Check the values again. The code could already be in use as well. Please reach out to support@lemontaps.com and send a picture of the QR code.',
      successDelete: 'Card removed',
      errorDelete: 'Card could not be removed',
      codeDelete: 'Remove card',
      areYouSureDelete: 'Do you really want to remove this card?',
      headToolTip:
        'Any number of cards can be connected to a profile. When a card is removed, the profile is no longer on the card and the card can be linked to a new profile.',
      bottomToolTip:
        'As an admin you can link the card by scanning the QR code. You can also distribute the card to the employees, they can log in to link the card to their profile.',
      cardAlreadyConnected: 'This card is already connected to this account',
      cardFrom: 'Card from',
      nodate: 'The date is not available for cards that were connected prior to 10/20/2022.',
      notValid: 'Code is not valid',
    },
    md2Phone: {
      popupStep1: 'Step 1: Scan the following QR code with your mobile phone',
      popupStep2:
        'Step 2: Now follow the instructions on the mobile phone and scan the QR code of the card. The QR-Code is valid for 24 hours.',
      title: 'Scan the QR code of the card',
      subTitle:
        'The card is then automatically linked to the profile from the Management Dashboard.',
      success:
        'Card was successfully linked to the profile.\n Please close the screen and go back to the Management Platform and refresh the page to see the changes or newly connected card!',
      noCodeToken: 'No code or token found, please close the page and try again.',
    },
    csvImport: {
      label: 'Bulk Actions',
      add: 'Add Profiles',
      update: 'Update Profiles',
      delete: 'Delete Profiles',
      toast: {
        added: 'Profiles added successfully',
        backgroundImport:
          'You will receive an e-mail as soon as the profiles have been created. This may take a little while.',
        otherCards: 'Order new cards',
        selectedCards: 'You have selected to order @amount card(s) during the .csv import.',
        cardsMessage:
          'These will be produced in the same design as your last order. You will receive an invoice of all newly ordered cards and licenses once per quarter.',
        addedThenError: 'Profiles added successfully, but the re-loading failed',
        updated: 'Profiles updated successfully',
        updatedThenError: 'Profiles updated successfully, but the re-loading failed',
        deleted: 'Profiles deleted successfully',
        deletedThenError: 'Profiles deleted successfully, but the re-loading failed',
        exceedtotalLicensing0: 'License quota exceeded',
        exceedtotalLicensing1: `If you add more profiles, you will exceed the number of your paid licenses.
          You will receive an invoice by email at the end of the month for the newly added licenses. You will be charged the license fees only proportionally to the remaining contract period.

          Do you still want to continue?`,
        exceedtotalLicensing2: 'Available licences:',
        exceedtotalLicensing3: `You have selected to order @amount card(s) during the .csv import.
        These will be produced in the same design as your last order. You will receive an invoice of all newly ordered cards and licenses once per quarter.

        If you add more profiles, you will exceed the number of your paid licenses.

You will receive an invoice by email at the end of the month for the newly added licenses. You will be charged the license fees only proportionally to the remaining contract period.

                  Do you still want to continue?`,
        continue: 'Continue',
        employeesLicenses: 'Employees Licenses',
      },
      errors: {
        header: 'User import error',
        length: {
          header: '-----------------\nUser "{{user}}" has the following error(s): \n',
          field: '  {{field}} cannot be longer than {{length}} characters.\n',
          fields: '  {{fields}} cannot be longer than {{length}} characters.\n',
          amount: '  {{field}} cannot be bigger than {{amount}}.\n',
        },
        invalidEmails: 'Invalid emails: \n "{{emails}}"',
        disposableDomains: 'Throwaway emails: \n "{{domains}}"',
        duplicatedEmails: 'These emails are duplicates in the uploaded file: \n "{{emails}}"',
        existedEmails:
          'Accounts with these emails already exist (possibly outside your team): \n "{{emails}}"',
        missedParams: '"{{params}}" are required attributes but they are missing in row "{{row}}"',
        invalidParam: 'Invalid {{param}} in row {{row}}',
        invalidCodes: 'Invalid codes: "{{codes}}"',
        trialUsersExceeded: 'Trial subscriptions can only have a maximum of {{max}} profiles.',
      },
    },
    referrals: {
      heading: 'Get your NFC-card for free',
      subtext:
        "Collect credits to get your free NFC card or Teams license now. All you have to do is invite your colleagues or friends to Lemontaps or write a Linkedin post. If you support us through multiple bonus promotions, we'll add up the points.",
      balance: {
        title: 'Your current credit balance',
        tooltip:
          'You can use your credit to buy Lemontaps products. Cash withdrawal is not possible.',
      },
      redeem: {
        title: 'Redeem your credits right away!',
        button: 'Redeem Credits',
        popup: {
          title: 'Redeem credits?',
          success:
            'Please contact us at <0>support@lemontaps.com</0> to let us know you want to redeem the credit.\nPlease mention the item you want to get.',
          failed: 'Your current balance is not sufficient for this item yet. Keep referring!',
        },
      },
      collect: {
        title: 'Collect Credits',
        email: {
          title: 'Invite your contacts',
          subtext:
            'Invite your colleagues, friends or contacts to Lemontaps with your business email and earn <0>2€ in credits</0> per verified registration.',
          tooltip:
            'Only accounts with business emails (no gmail, etc.) that have also completed the onboarding count.',
          placeholder: 'business e-mail',
          button: 'Send Invitation',
          copyButton: 'Copy sharable link',
        },
        linkedin: {
          title: 'Get 15€ credit for free',
          subtext:
            'Tag us on your next LinkedIn post about Lemontaps and get <0>15€ in credits</0> right away. <1></1>Just send us the link to the post to <2>contact@lemontaps.com</2>, and we will confirm your new credit.',
        },
      },
      toast: {
        emailError: 'Please insert a valid company email',
        emailSuccess: 'Email sent successfully',
        linkSuccess: 'Link copied to clipboard',
      },
      menuButton: 'Refer & Earn',
      card: 'Get a Free NFC-Card',
    },
    selectFromList: 'Select from list',
    send: 'Send',
    hereIsMyContact: 'Here is my contact',
    myContact: 'My contact',
    profileImageUpdated: 'Profile image updated',
    bannerImageUpdated: 'Banner image updated',
    logoImageUpdated: 'Logo image updated',
    defaultAddresses: 'Default Addresses',
    error: {
      general: 'Something went wrong, please reload the page and try again.',
      editBio: 'Error in saving Data.',
      defaultAddress: 'Unable to update default address template.',
      defaultLink: 'Unable to update default link.',
      defaultFile: 'Unable to update default file.',
      uploadFile: 'Unable to upload file.',
      updateFile: 'Unable to update file.',
      updateLink: 'Unable to update link.',
      deleteLink: 'Unable to delete link.',
      deleteFile: 'Unable to delete file.',
      uploadingImage: 'Error uploading image',
      updatingImage: 'Error updating image',
      updateAccounts: 'Failed to update accounts. Please try again!',
      errorDownloadQr: 'Maximum 10 profiles can be selected for this action.',
      successfullySent: 'Successfully sent',
      disposableEmail: 'Using a disposable email is not allowed!',
      invalidEmail: 'Please use a valid email format!',
      required: 'Required field',
      existedEmail: 'Email already in use! Please use another email.',
      socialEmail:
        'You are registered through a social provider. Log in there to change your email.',
      requiredFieldGeneral: 'Required field',
      invalidFieldGeneral: 'Invalid format',
      minOneFieldRequired: 'Minimum one field required',
      pleaseFillOutRequired: 'Please fill out the required fields',
      maxLength: 'Maximum {{value}} characters',
      cantDowngradeMainAdmin: 'Cannot downgrade the team owner.',
    },
    teaser: {
      starterBullets: [
        'Digital business card for mobile & desktop',
        'Upload unlimited links & files',
        'Apple Wallet, QR Code, QR Backgrounds ',
        'Analytics & Insights',
      ],
      proBullets: [
        'Central user management',
        'Use an individual company domain',
        'Subdivision into subgroups',
        'Corporate design profile',
        'Add Templates & Images ',
        'Distribute roles & rights',
        'Mass export of QR codes/wallet',
        'Contact capture and management',
        'AI business card scanner for leads',
        'Interfaces: SSO, MS AD, CRM possible',
        'Training videos & Prio support',
      ],
      enterpriseBullets: [
        'Whitelabel functionalities such as internal design, favicon, email editor, etc.',
        'Subdivision into subgroups with specific design & settings',
        'Translation of profile content into any language',
        'Lead reporting functions for trade fairs',
        'Personal consulting & onboarding',
        'Rollout & best-practice consulting',
        'Lemontaps Academy video series',
        'Dedicated support and SLA',
        'Custom code adjustments',
      ],

      starterShortDescr:
        'Create your digital business card profile for yourself easily & free of charge.',
      teamsShortDescr:
        'Use Lemontaps in a team (1-50 users) and according to your corporate guidelines.',
      enterpriseShortDescr:
        'Recommended for teams of 50 people or more with extended security, control and support functions.',

      testItXDaysForFree: 'Try {{days}} days for free',
      centralUserAdministration: 'Central User Administration',
      easilyDataOfAllEmployees:
        'Easily enter, edit, and manage data of all employees for profile creation.',
      leadRecording: 'Lead Capture',
      noCredit: 'No credit card or cancellation required.',
      noInstallation: 'No installation required',
      contacts:
        'Contacts can be recorded digitally through the lead form on your profile or in your own view and automatic follow-up emails can be sent.',
      contactsLand:
        'Contacts are sorted chronologically by time and date in the contact management system. Here, further information can be added (such as notes and images) to avoid forgetting the person.',
      manageContacts: 'Manage Contacts',
      makeContacts: 'Take Contacts',
      packageComparison: 'Compare All Packages',
      starter: 'Starter',
      individualUser: 'For individual users',
      noPayment: 'Free forever. No credit card required.',
      currentPlan: 'Current Plan',
      basicFeature: 'Basic Features:',
      teamEssential: 'Essential for Teams',
      groupUsers: '1 - 50 users',
      peruserpermonth: 'Per user/month when payed yearly.',
      graduatedprices: 'Graduated prices for licenses and NFC cards.',
      costless: 'Try {{days}} days for free',
      allStarterFeatures: 'Starter features, plus:',
      allProFeatures: 'Teams features, plus:',
      allFeatures: 'All Teams Features, plus:',
      platformManagment: 'Management platform for central user administration',
      trading: 'Profile according to corporate branding',
      contact: 'Contact recording',
      fiftygroupUsers: 'Recommended for 50+ users',
      recievedError: 'Receive offer',
      allTeamsFeature: 'All Teams Features plus:',
      settelment: 'Consolidated into multiple units/locations',

      individualAdjustment: 'Individual adjustments like emails and internal design',
      standard: 'Default links/addresses templates',
      askUs: 'Ask us for an offer',
      hunderdsgroupUsers: 'Companies with 50+ users',
      allCompanyFeatures: 'All company features, plus:',
      premiumSupport: 'Premium support and SLA',
      comparison: 'Compare all pricing plans and features',
      popular: 'Most popular for teams',
      adminManagment: 'Admin management',
      importantFunction: 'Important functions at a glance',
      centralUser: 'Central user management',
      easyData: 'Easily enter, edit, and manage data for all employees for profile creation.',
      corporateIdentity: 'Profile according to corporate identity',
      designDigitalProfile:
        'Design your digital profile according to your colors, shapes, logo, and standard background images.',
      individualProcessing: 'Individual processing rights',
      access: 'Decide who should have which access and processing rights.',
      leader: 'Lead capture',
      efficientContact:
        'Your team can efficiently contact, manage and send automatic follow-up emails via the profile.',
      myProfile: 'My profile',
      noCancellation: 'And no cancellation required',
      expired: 'Your trial period has expired.',
      moreInfo: 'More info about our plans',
      companyName: 'What is the name of your organization?',
      potentialUser: 'How many potential users are there?',
      stratNow: 'Start now!',
      upgradeSubtext: 'or upgrade',
      salesSubtext: 'or contact sales',
      collectLeadsWithLt: 'Collect leads with Lemontaps',
      leadGen: {
        header: 'Try Lemontaps Pro for free',
        subheader:
          'Efficiently scan paper business cards or capture contacts via the lead form. Manage your contacts and transfer them to your CRM system (Salesforce, Hubspot, Pipedrive, and Dynamics).',
      },
      teams: {
        header: 'Try Lemontaps Teams for free',
        subheader:
          'The most efficient solution to equip your entire team with digital business cards. Try our most popular features for free.',
      },
    },
    upgradeTeaser: {
      upgradeYourPlan: 'Upgrade required - Do you want to test this feature for free?',
      contactUs: 'Contact us.',
      enableForTrial: 'Get access to this for the trial period!',
      feature: {
        qrCodeSettings: 'Customize the QR code design.',
        bioFieldsConfig: 'Configure which fields should be visible on the profile.',
        profiles:
          "Create a team to manage all your employees' profiles from within our central management dashboard.",
        leadGenInternalContactForm:
          'Configure which fields should be available internally for managing contacts.',
        vcardConfig: 'Configure which information to include in downloaded contacts',
        units:
          'Group users into units that can be managed by sub-admins. You can also configure unit-level configurations, such as a unit-level profile design. This feature is not available in your current plan.',
        leadgenMd:
          'Find all contacts/leads collected by all employees in one place using the contact form in the public profile. Edit and export the contacts. This feature is not available in your current plan.',
        leadgenIndividual:
          'Find all contacts/leads you have collected in the public profile using the contact form. This feature is not available in your current package.',
        themeLinks: 'Default links are not available in your current plan.',
        themeFiles: 'Default files are not available in your current plan.',
        themeAddresses: 'Default addresses are not available in your current plan.',
        dataTemplates:
          'Create templates for standard addresses, links, and files. If these templates are changed here, the changes will be immediately reflected in all profiles that have added this template. This feature is not available in your current plan.',
        globalData: 'Create links, files, or addresses that are visible on all profiles.',
        emailTemplates:
          'Customize the emails sent out from Lemontaps with your own design and text. You can edit the invitation email and the emails for the contact form.This feature is not available in your current plan.',
        leadGenContactForm:
          'Customize the contact form on the profile page of your team members. Decide which fields are mandatory, which fields are optional, and which fields are not displayed. This feature is not available in your current plan.',
        mdAnalytics: 'Analyze cross-profile aggregated statistics on the usage of your employees.',
        analyticsIndividual: 'Analyze statistics about your profile.',
        internalDesign: 'The Internal Design is not available in your current plan.',
        unitHierarchies: {
          visibilityConfig: 'Configure which fields should be visible on the profile.',
          leadGenInternalContactForm:
            'Create a custom internal form for this unit. This feature is not available in your current plan.',
          leadGenContactForm:
            'Create a custom external form for this unit. This feature is not available in your current plan.',
          editRightsTheme:
            'Override the edit rights for the theme. This feature is not available in your current plan.',
          editRights:
            'Override the edit rights for this unit. This feature is not available in your current plan.',
          editRightsGeneral:
            'Decide which unit-specific settings may be managed by unit admins themselves. This feature is not available in your current plan.',
          profileDesign:
            'Override the profiledesign for this unit. This feature is not available in your current plan.',
          emailSignature:
            'Design your own email signature for this unit. This feature is not available in your current plan.',
          emailTemplates:
            'Customize the emails sent out from Lemontaps with your own design and text. You can edit the invitation email and the emails for the contact form. This feature is not available in your current plan.',
          walletConfig:
            'Override the wallet config for this unit. This feature is not available in your current plan.',
          qrCodeBackgroundConfig:
            'Override the QR code background config for this unit. This feature is not available in your current plan.',
          qrCodeSettings:
            'Override the QR code config for this unit. This feature is not available in your current plan.',
        },
        translations:
          'Translate the digital business card profiles of your team. You can translate the standard text, contact information, link names, links and file names. You can also decide not to show information in certain languages. This feature is not available in your current plan.',
        businessCardScanner:
          'Digitize and import contact data from paper business cards to Lemontaps, CRM or Outlook. In compliance with GDPR and in a matter of seconds.',
        visibilityConfig: 'Select to hide certain pages and content elements.',
        idp: 'Integrate your Identity Provider to set up Single Sign-On and User Provisioning.',
        emailSignature:
          'Design your own email signature. This feature is not available in your current plan.',
        profileDesign: 'Customize the profile design for all profiles of your team.',
        walletConfig: 'Customize the Apple and Google wallet configuration for your team.',
        qrCodeBackgroundConfig:
          'Customize the QR code background design for all profiles of your team.',
      },
    },
    globalSettings: 'Further global settings',
    integrations: {
      title: 'Integrations',
      subtitle:
        'Lemontaps can be optimally integrated into your system landscape. The following integrations can be optionally added.',
      connect: 'Connect',
      configure: 'Configure',
      connected: 'Connected',
      inProgress: 'In Progress',
      customDomain: {
        title: 'Custom Domain',
        description: 'Connect your digital profiles to your own subdomain/URL.',
        popupDescription: 'Choose a subdomain you want to use. Then write an email to {{email}}.',
      },
      sso: {
        title: 'SSO Login',
        description: 'Integrate a secure SSO/SAML corporate access.',
      },
      activeDirectory: {
        title: 'Active Directory',
        description: 'Profile data can be synchronized with your Active Directory.',
      },
      crm: {
        title: 'CRM',
        description: 'Synchronize collected contacts.',
      },
    },
    contactsTable: 'Contacts Table',
    findOutMore: 'Find out more',
    manual: 'Manual',
    businessCardScanner: {
      automaticallySendContactToEmailHelperText:
        'An admin has locked this option. The follow-up email will be sent after saving the contact.',
      noDataFoundBusinessCard: 'No data found',
      noDataFoundBadge: 'No data found',
      noDataFoundLinkedIn: "Couldn't read QR-Code",
      noDataFound: 'No data found',
      title: 'Business Card Scanner',
      infoText: {
        businessCard:
          'Place the business card on a table, make sure it is fully visible, and take a photo.',
        badge: 'Capture a fair badge',
        linkedin: 'Capture a QR-Code',
      },
      infoTextFront: 'Capturing front',
      infoTextBack: 'Capturing back',
      enterMinOne: 'Fill in at least one field to continue',
      infoEmailWillBeSent:
        'When you click "save", an email with your contact info will be sent to this contact',
      cameraNotAvailable:
        'Something went wrong. Check if camera access is granted or camera is not in use by other application.',
      fileCaptureError: 'Error. Try again.',
      addContactSuccess: 'Contact saved',
      addContactError: 'Error saving contact',
      upload: 'Upload',
      loadingTitle: 'Analyzing',
      savingTitle: 'Saving',
      loadingSubtitle: 'It usually takes a couple of seconds',
      businessCardTitle: 'Select correct values',
      businessCardSubtitle: 'You can also edit the attributes later.',
      retake: 'Retake',
      next: 'Next',
      sendContactToEmail: `Send my business card to {{email}}`,
      gdprTitle: 'GDPR',
      gdprSubtitle: 'Please select the legal basis for saving this contact.',
      noFieldsAvailable:
        'No attributes could be recognized. Click on "Next" to create the contact manually.',
      fileSelectSizeError: 'Please select a file that is smaller than 10MB.',
      fileSelectMaxFileSelectError: 'Please select a maximum of {{count}} files',
      edit: {
        nothingDetectedAlertTitle: 'Nothing detected',
        nothingDetectedAlertBody: 'Please hand your phone over to fill out the form.',
        missinContactInfoAlertTitle: 'Missing Contact Info',
        missinContactInfoAlertBody:
          'We need at least the first, last name and company to enrich the contact information.',
      },
      permissionDenied: {
        preText: 'Follow instructions to enable camera access',
        desktop: {
          firefox:
            "Click the shield icon in the address bar, select 'Permissions', find 'Use the Camera', and choose 'Allow'. Refresh the page afterwards.",
          chrome:
            "Click the padlock icon in the address bar, select 'Camera', choose 'Allow', and then refresh the page.",
          safari:
            "Click the 'aA' icon in the address bar, choose 'Website Settings', select 'Allow' next to Camera, and then refresh the page.",
          edge: "Click the padlock icon in the address bar, select 'Camera', choose 'Allow', and then refresh the page.",
          opera:
            "Click the padlock icon in the address bar, select 'Camera', choose 'Allow', and then refresh the page.",
        },
        mobile: {
          firefox:
            "Click the shield icon in the address bar, select 'Permissions', find 'Use the Camera', and choose 'Allow'. Refresh the page afterwards.",
          chrome:
            "Tap on the three dots menu or the 'More' icon, go to 'Settings', find 'Site Settings', tap on 'Camera', and ensure it's set to 'Ask first' or 'Allowed'.",
          safari:
            "Go to the iOS 'Settings' app, scroll down to 'Safari', tap on 'Camera', and select 'Allow'",
          edge: "Tap on the three dots menu, go to 'Settings', tap 'Site permissions', choose 'Camera', and set it to 'Ask before accessing'.",
          opera:
            "Open the menu, go to 'Settings', find 'Site Settings', select 'Camera', and set it to 'Ask first' or 'Allowed'.",
        },
      },
      showFront: 'Show front',
      showBack: 'Show back',
      captureFront: 'Capture front',
      captureBack: 'Capture back',
    },
    freeTrialBanner: {
      ongoing: {
        line1_one: 'You have {{count}} day remaining of your free {{days}}-day trial of Lemontaps.',
        line1_other:
          'You have {{count}} days remaining of your free {{days}}-day trial of Lemontaps.',
        line2:
          ' to continue to use all features of Lemontaps after the trial period has expired. <0>What happens after my trial period?</0>',
      },
      finished: {
        line1: 'Your trial has expired',
        line2:
          ' to regain access to all features. All your resources and settings are still saved and you can regain access after upgrading.',
      },
    },
    mobilePopupText:
      'Browser width is too small. Please open this page on a desktop device or resize your browser to at least {{pixel}}px to access the management platform.',
    onboardingReferrer: {
      google: 'Google',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      referral: 'Recommendation / Referral',
      event: 'Event',
      email: 'E-Mail',
      friends: 'Friends',
      bing: 'Bing',
      recommendation: 'Empfehlung',
      chatgpt: 'ChatGPT / Bing Copilot',
      blog: 'Blog Post',
    },
    option: 'Option',
    custom: 'Custom',
    scannable: 'Scannable',
    contactFormEdit: {
      tooltips: {
        upstreamLeadObjectType:
          'Only visible if there is an active CRM connection and the setting "Allow users to choose between contact or lead" is active.',
        email: 'Follow-up emails are sent to this address.',
      },
      resetToDefaultLabel: 'Default name:',
      saveTooltip: 'At least one field must be marked as required.',
      fullName: 'Name',
      required: 'Required',
      optional: 'Optional',
      notShown: 'Not displayed',
      shown: 'Displayed',
      title: 'Configuration of the contact form',
      businessCardUrls: 'Business Card Image',
      description: 'These settings will be applied to all profiles of your team.',
      atLeastOneRequired: 'At least one field must be marked as required.',
      usedInExternal: 'You cannot deselect a field that is still visible in the external form.',
      deletingUsedInExternal: 'The field you want to delete is still visible on the external form.',
      external: {
        title: 'External form',
      },
      internal: {
        title: 'Internal form',
        deletePopupTitle: 'Are you sure you want to delete the field?',
        deletePopupBody:
          'All information that has been captured with this field is going to be deleted. This cannot be undone.',
        questionTitle: 'Field Name',
        answerOptions: 'Field Options',
        addOption: 'Add Option',
        editField: 'Edit Field',
        deleteField: 'Delete Field',
        editSystemField: 'Edit system field label',
        customFields: {
          crmCustomFields: {
            title: 'CRM Custom Field',
            tooltip: 'CRM Custom Field tooltip.',
            addDialogTitle: 'Select Custom Field',
            addDialogDescription:
              "Find all available CRM custom fields here and add them to your lead form - they'll sync automatically when a Lemontaps contact is pushed.",
            chipTitle: 'Synced',
          },
          text: {
            title: 'Text',
            tooltip: 'A single line text input',
          },
          textarea: {
            title: 'Textarea',
            tooltip: 'A multiline text input',
          },
          checkbox: {
            title: 'Checkboxes',
            tooltip: 'Multi-select via checkboxes',
          },
          dropdown: {
            title: 'Dropdown',
            tooltip: 'Single-select via a dropdown',
          },
          radio: {
            title: 'Radio Buttons',
            tooltip: 'Single-select via radio buttons',
          },
          'checkbox-single': {
            title: 'Checkbox',
            tooltip: 'Single-select (yes/no) via a single checkbox',
          },
          'multi-select': {
            title: 'Multi-Select',
            tooltip: 'Multi-select via a dropdown',
          },
          date: {
            title: 'Date',
            tooltip: 'Date picker (without time)',
          },
          datetime: {
            title: 'Date and Time',
            tooltip: 'Date picker (with time)',
          },
          number: {
            title: 'Number',
            tooltip: 'Single Numeric input',
          },
          attachments: {
            title: 'Attachments',
            tooltip: 'Supports png, HEIC, mp4, mov, pdf',
          },
          signature: {
            title: 'Signature field',
            description:
              'This text will be displayed before the signature field in the app. You can show terms here that participants are required to sign. Add HTML links (e.g. <a href="...">Privacy Policy</a>) that appear as clickable links in the app.',
            tooltip: 'Signature field tooltip.',
          },
        },
        alert: {
          title: 'Business card scanner fields.',
          body: 'Those fields marked with "Scannable" can be scanned via the business card scanner. Fields marked with "AI" can be enriched using AI.',
        },
      },
    },
    signature: {
      add: 'Add signature',
      delete: 'Delete signature',
      download: 'Download PDF',
    },
    deleteAccount: {
      title: 'Delete Account',
      pageTitle: 'Danger Zone',
      buttonText: 'Delete My Account',
      popupTitle: 'Are you sure you want to delete your account? You cannot undo this!',
      popupBody:
        'All data associated with this account will be permanently deleted. This cannot be undone.',
      popupEmailLabel: 'Enter the email address that you are registered with',
      success: 'Your account has been deleted.',
      emailMismatch: 'The email does not match the one you are registered with.',
      confirm: 'Yes, delete account',
    },
    emailTemplates: {
      settings: {
        title: 'Email Settings',
        addLangTitle: 'Configure New Language',
        confirmDeleteLang: 'Are you sure you want to delete language for email templates?',
        enableDisableEmails: 'Enable/Disable Emails',
        enableDisableEmailsDescr:
          'You don’t want to trigger certain Emails? Enable or disable them',
        enableDisableEmailsTooltip:
          'Here you can disable certain emails. Disabled emails are not sent out.',
        externalEmailLanguages: 'External Email Languages',
        internalEmailLanguages: 'Internal Email Languages',
        externalEmailLanguagesTooltip:
          'Select which languages to create email templates for external recipients such as contacts outside your organization. These languages will be available in the template editor. To add a new language option, you must first configure it in the translation settings.',
        internalEmailLanguagesTooltip:
          'Select which languages to create email templates for internal recipients (team members with Lemontaps accounts). These languages will be available in the template editor. You can only select between German and English.',
        setFallback: 'Set as fallback',
        addLang: 'Add Language',
        emailRecipients: 'Email Recipients',
        emailRecipientsDescr: 'Configure the recipients of the emails.',
        changeRequestsEmailRecipients: 'Change Requests Email Recipients',
        editRecipients: 'Edit Recipients',
        addRecipient: 'Add Recipient',
        recipient: 'Email of recipient',
        invalidEmail: 'Invalid email',
        automaticallySendFollowUpEmail:
          'Always send the follow-up email after a new contact is saved',
        automaticallySendFollowUpEmailTooltip:
          'When this option is enabled, the follow-up email will be automatically triggered whenever a new contact is created, regardless if via the business card scanner, manually via the dashboard, or collected via the contact form on the profile page.',
      },
      contentCopied: 'Content copied',
      errorCopying: 'Error copying',
      contentPasted: 'Content pasted',
      errorPasting: 'Error pasting',
      noContentToPaste: 'There is no content to paste',
      copyTooltip: 'Copy email content',
      pasteTooltip: 'Paste email content',
      upgradeAlertTitle: 'Limited Email Editor',
      upgradeAlertBody:
        'You do not have full editing rights for the email editor and therefore cannot change the font and colors and cannot upload images or remove the Lemontaps branding.',
      noSetPasswordUrlAlert:
        'The placeholder $SET_PASSWORD_URL$ is not included in the template currently. If you do not include this URL in the email, the invited user will not be able to set a password and login to their account.',
      selectTemplate: 'Select E-Mail',
      selectLanguage: 'Select Language',
      errorUploadingImage: 'Error uploading image',
      errorSaving: 'Error while saving',
      errorSendingTestEmail: 'Error while sending test email',
      successfullySaved: 'Successfully saved',
      testEmailSuccessfullySent: 'Test email successfully sent',
      standardLocale: 'Default',
      enLocale: 'English',
      deLocale: 'German',
      'welcome-email-template': 'Invitation email to employees',
      'contact-share-email-template': 'Contact form: Email to new contacts',
      'contact-received-email-template': 'Contact form: Internal notification',
      'generic-status-email': 'General purpose informational email',
      'qr-bg-complete-email-template': 'Status Email: QR-Code Background Generation',
      'qr-complete-email-template': 'Status Email: QR-Code Generation',
      'card-order-confirmation-email-template': 'Card order confirmation email',
      'referral-email-template': 'Referral Invitation email',
      'referral-referrer-template': 'Referral completed: Email to referrer',
      'referral-recipient-template': 'Referral completed: Email to recipient',
      'wallet-pass-mail-template': 'Wallet email',
      'onboarding-email-template': 'Onboarding email',
      testEmailSendPopupTitle: 'Send test email to',
      testEmailSendPopupSubtitle:
        "The dynamic information in the email is based on your profile's data.",
      sendTestEmail: 'Send test email',
      content: 'Content',
      layout: 'Layout',
      columns: 'Columns',
      column: 'Column',
      editView: 'Edit View',
      desktopPreview: 'Desktop Preview',
      mobilePreview: 'Mobile Preview',
      duplicateTitle: 'Duplicate Contents To',
      attachments: 'Attachments',
      attachmentKeys: {
        'offline-apple-wallet': 'Offline Apple Wallet',
        'online-apple-wallet': 'Online Apple Wallet',
      },
    },
    emailSignature: {
      title: 'Email Signature',
      management: {
        title: 'Email Signature Management',
        description: 'Create and manage multiple email signatures with rules-based selection.',
        createSignature: 'Create Signature',
        orderDescription:
          'The signatures are displayed below in the order in which they are evaluated.',
        noSignatures: 'No signatures found. Create your first signature to get started.',
        fetchError: 'Failed to fetch signatures',
        deleteSuccess: 'Signature deleted successfully',
        deleteError: 'Failed to delete signature',
        deleteConfirmation:
          'Are you sure you want to delete this signature? This action cannot be undone.',
        reorderSuccess: 'Signatures reordered successfully',
        reorderError: 'Failed to reorder signatures',
        lastEdited: 'Last Edited',
        createdAt: 'Created At',
        draft: 'Draft',
        actions: {
          edit: 'Edit',
          duplicate: 'Duplicate',
          delete: 'Delete',
        },
      },
      signatures: 'Signatures',
      noSignatures: 'No signatures found',
      createFirstSignature: 'Create your first signature to get started',
      create: 'Create Signature',
      edit: 'Edit',
      delete: 'Delete',
      duplicate: 'Duplicate',
      activate: 'Activate',
      deactivate: 'Deactivate',
      active: 'Active',
      inactive: 'Inactive',
      name: 'Name',
      description: 'Description',
      priority: 'Priority',
      status: 'Status',
      rules: 'Rules',
      languages: 'Languages',
      created: 'Created',
      actions: 'Actions',
      tableView: 'Table View',
      cardView: 'Card View',
      reordering: 'Reordering signatures...',
      deleteSuccess: 'Signature deleted successfully',
      reorderSuccess: 'Signatures reordered successfully',
      updateSuccess: 'Signature updated successfully',
      createSuccess: 'Signature created successfully',
      editSuccess: 'Signature updated successfully',
      duplicateSuccess: 'Signature duplicated successfully',
      saveAsDraftSuccess: 'Signature saved as draft',
      publishSuccess: 'Signature published successfully',
      wizard: {
        loadingSignature: 'Loading signature...',
        title: {
          create: 'Create New Signature',
          edit: 'Edit Signature',
          duplicate: 'Duplicate Signature',
        },
        saveAsDraft: 'Save as Draft',
        saveAndConvertToDraft: 'Save and Convert to Draft',
        publish: 'Publish',
        next: 'Next',
        designSignature: 'Design Signature',
        saveAndDesign: 'Save and Design',
        steps: {
          basicInfo: 'Name',
          senderRules: 'Senders',
          receiverRules: 'Receivers',
          temporalRules: 'Scheduler',
          templateLogic: 'Template Logic',
          languageConfig: 'Translations',
          signatureDesign: 'Design',
        },
        basicInfo: {
          title: 'Name',
          description: 'To start name your signature and click next.',
          nameLabel: 'Name of your signature',
          namePlaceholder: 'Global (Default)',
          nameHelp: 'Enter a descriptive name for this signature.',
          descriptionHelp: 'Optional description to help identify this signature.',
          priorityHelp: 'Lower numbers have higher priority (0 = highest).',
        },
        senderRules: {
          description: 'Select which users can use the signature.',
          includeTitle: 'Include the following senders:',
          excludeTitle: 'Exclude the following senders:',
          allSenders: 'All senders',
          ruleType: 'Include the following senders:',
          specificSenders: 'Specific senders',
          noExclusions: 'No exclusions',
          specificExclusions: 'Specific exclusions',
          units: 'Units',
          excludeUnits: 'Exclude the following senders:',
          selectUnits: 'Select units...',
          selectExcludeUnits: 'Select units to exclude...',
        },
        receiverRules: {
          title: 'Receiver Rules',
          description:
            'The signature can be applied to all emails sent or only to specific receivers.',
          comingSoon: 'Receiver rules configuration coming soon...',
          receiverType: 'Receiver Type',
          allReceivers: 'All receivers',
          internalOnly: 'Internal only',
          externalOnly: 'External only',
          specificEmails: 'Specific email addresses',
          includePatterns: 'Include patterns (optional)',
          excludePatterns: 'Exclude patterns (optional)',
          includeReceivers: 'Include receivers (optional)',
          includeReceiversHelp: 'Enter one or multiple email addresses separated by semicolons.',
          includeReceiversLabel: 'Include email addresses',
          includeReceiversPlaceholder: 'Enter email addresses...',
          includeReceiversExample: 'Example: info@lemontaps.com; *@lemontaps.com; *@onmicrosoft.*',
          includePatternsHelp:
            'Enter one or multiple email patterns separated by semicolons. Use * as wildcard.',
          excludePatternsHelp:
            'Enter one or multiple email patterns to exclude, separated by semicolons. Use * as wildcard.',
          includePatternsLabel: 'Include email patterns',
          excludePatternsLabel: 'Exclude email patterns',
          includePatternsPlaceholder: 'Enter email patterns...',
          excludePatternsPlaceholder: 'Enter email patterns to exclude...',
          includePatternsExample: 'Example: info@lemontaps.com; *@lemontaps.com; *@onmicrosoft.*',
          excludePatternsExample: 'Example: noreply@lemontaps.com; *@spam.com',
        },
        temporalRules: {
          title: 'Time Rules',
          description: 'Configure time-based rules for signature selection.',
          comingSoon: 'Time rules configuration coming soon...',
          schedulerEnabled: 'Enable scheduler',
          schedulerHelp:
            'You can keep this signature rule active continuously or specify time ranges when this rule applies.',
          timezone: 'Select timezone',
          timeFrame: 'Select time frame',
          selectTimeFrame: 'Select time frame...',
          activeHours: 'Active hours',
          from: 'From',
          to: 'To',
          info: 'You can keep this signature rule active continuously or you can turn on Scheduler to specify time ranges when this rule adds signatures. This step is optional and you can skip it.',
        },
        templateLogic: {
          title: 'Template Logic',
          description: 'Configure how this signature should be available as a template.',
          templateAvailabilityQuestion:
            'Should this signature be available as templates to the selected senders to choose from if the signature is not applied by default?',
          templateAvailabilityYes: 'Yes',
          templateAvailabilityYesWithRules: 'Yes, but only if the other rules match',
          templateAvailabilityNo: 'No',
          info: 'This step determines whether users can manually select this signature as a template option.',
        },
        languageConfig: {
          title: 'Language Configuration',
          description:
            'You can add different language versions to choose from. By default the signature is in the users account language. This step is optional and you can skip it.',
          comingSoon: 'Language configuration coming soon...',
          active: 'Active',
          contentPlaceholder: 'Signature content',
          contentHelp:
            'Enter the signature content for this language. You can use HTML formatting.',
          inactiveMessage: 'This language is currently inactive. Enable it to add content.',
          info: 'Configure signature content for each language. Only active languages will be used when generating signatures.',
          enableTranslations: 'Enable translations',
          fallbackLanguage: 'Fallback Language',
          setAsFallback: 'Set as fallback',
          cannotDisableTranslations: 'Cannot disable translations once enabled',
          translationsDisabled:
            'Translations are disabled. The signature will use the default language.',
        },
        signatureDesign: {
          title: 'Design',
          description: 'Design your email signature content and layout.',
          comingSoon: 'Signature design configuration coming soon...',
          contentEditor: 'Content Editor',
          htmlContent: '{{language}} Content',
          htmlPlaceholder: 'Enter HTML content for your signature...',
          htmlHelp:
            'You can use HTML tags for formatting. Basic tags like <b>, <i>, <a>, <img> are supported.',
          noActiveLanguages:
            'No active languages found. Please enable at least one language in the Language Configuration step.',
          customHtml: 'Custom HTML Override',
          customHtmlHelp:
            'Optional: Override the template with custom HTML. This will replace the template completely.',
          customHtmlLabel: 'Custom HTML',
          customHtmlPlaceholder: 'Enter custom HTML code...',
          customHtmlHelper: 'Advanced: Use this to completely customize your signature HTML.',
          previewInfo: 'You can preview your signature in the next step or after saving.',
          readyToDesign: 'Ready to Design Your Signature',
          designDescription:
            'Your signature configuration is complete. Click the button below to save and open the full email signature designer where you can create beautiful, professional signatures.',
          saveAndDesign: 'Save and Design Signature',
          templateAvailabilityQuestion:
            'Should this signature be available as templates to the selected senders to choose from if the signature is not applied by default?',
          templateAvailabilityYes: 'Yes',
          templateAvailabilityYesWithRules: 'Yes, but only if the other rules match',
          templateAvailabilityNo: 'No',
        },
      },
      branding: {
        title: 'Email Signature Branding',
        font: 'Font',
        textColor: 'Primary Text Color',
        secondaryTextColor: 'Secondary Text Color',
        qrCodeColor: 'QR Code Color',
        configureQrCode: 'Configure QR Code Colors',
        infoAlert:
          'The settings will apply to new templates only. Existing templates are not updated.',
      },
      overview: {
        videoTitle: 'Introduction to the Lemontaps Signature Tool',
        videoPlaceholder: 'Video Tutorial',
        videoDescription: 'Learn how to set up and use email signatures with Outlook',
        getStarted: 'Get Started',
        connectOutlook: 'Connect with Outlook',
        brandingSettings: 'Branding Settings',
        signatures: 'Signatures',
      },
      setup: {
        title: 'Connect with Outlook',
        step1: {
          title: 'Step 1: Testing the integration - Local installation for my MS Outlook',
          description:
            'Try the add-in yourself first - team installation requires Outlook admin rights and can take up to 6 hours to activate.',
          downloadTitle: '1. Download the manifest',
          downloadButton: 'Download',
          openAddin: '2. Open',
          openAddinInstructions: 'This opens the add-in pop-up in Outlook.',
          uploadManifest: '3. Upload the manifest',
          uploadInstructions:
            "Choose 'My add-ins', go to 'Add custom add-in' and click on 'Add from file'",
          testAddin: '4. Test Add-in & Confirm Pop-up',
          testInstructions: [
            'Write a new mail:',
            'You will see "Authentication for signature failed"',
            'a popup will appear → allow it',
            'Now it should work, you can start designing the signature and test it out immediately.',
          ],
        },
        step2: {
          openMsAdmin: '1. Go to',
          insertManifest: '2. Insert the manifest link',
          selectMemebers: '3. Select Members',
          selectMembersInstructions:
            'For test purposes, we recommend that you first make the add-in available only to yourself or selected members.',
          title: 'Step 2: Installation for your Team',
          description: 'You require administrator rights in Microsoft 365',
          installationSteps:
            'Go to settings → "Integrated apps" → "Upload custom apps" → Choose "Office Add-In" under App type → Choose "Provide link to manifest file" → Insert the following link and click "Validate" → click "next"',
          manifestLink: 'Manifest link',
          testRecommendation:
            'For test purposes, we recommend that you first make the add-in available only to yourself or selected members.',
          grantAccess: '4. Option: Grant access to all members',
          grantInstructions:
            'Go to Identity > Enterprise Applications, search for "Outlook Signature Addin", click it, then under Security > Permissions, click "Grant admin consent" to enable it for all users.',
        },
        helpArticle:
          'For more detailed instructions (with screenshots) please see our help article',
        helpArticleLink: 'here.',
      },
    },
    export: {
      refresh: 'Refresh',
      title: 'Export',
      infoCard: {
        title: 'Export file is being generated',
        body: 'This may take some time. We will notify you by email as soon as it is ready for export.<0/><1>Note</1>: It may happen that the email is blocked by your company IT. In this case, please check the status directly on this exports page.',
      },
      emptyCard: {
        title: 'No files found',
        body: 'You have not exported any files in the past 14 days.',
      },
      fileCard: {
        errorTitle: 'Export failed...',
        runningTitle: 'Export file is being generated...',
        date: 'Exported {{date}}',
        status: {
          running: 'Export running....',
          finished: 'Export completed',
          failed: 'Failed',
        },
        action: {
          download: 'Download',
          retry: 'Try again',
          contact: 'Unexpected error. Please contact: <0>support@lemontaps.com</0>',
        },
        header: {
          qrPlain_one: '{{count}} {{type}} QR-Code',
          qrPlain_other: '{{count}} {{type}} QR-Codes',
          qrBg_one: '{{count}} QR-Code Background',
          qrBg_other: '{{count}} QR-Code Backgrounds',
          appleWallet_one: '{{count}} {{type}} Apple Wallet-Pass',
          appleWallet_other: '{{count}} {{type}} Apple Wallet-Passes',
          googleWallet_one: '{{count}} {{type}} Google Wallet-Pass',
          googleWallet_other: '{{count}} {{type}} Google Wallet-Passes',
        },
      },
    },
    verify: 'Verify',
    domains: {
      confirmClaimTitle: 'Confirm to continue',
      confirmClaimDescription:
        'Confirm that you want to continue with the selected action of claiming the selected accounts.',
      infoNotAvailable: 'Only available after verification',
      infoManagedAccountsCount:
        'Amount of accounts in your team registered with this email domain.',
      infoAvailableToClaimCount:
        'Amount of accounts registered with this email domain outside of your team that you can import into your team. This info is available only after domain verification.',
      infoAllAccountsCount: 'Sum of the other two columns.',
      pageTitle: 'E-Mail Domains',
      pageDescription: 'Manage your domains and subdomains.',
      domain: 'Domain',
      settings: 'Settings',
      autoClaimUserTooltipText: 'Existing accounts can be claimed by clicking on "Claim Accounts".',
      searchPlaceholder: 'Search for a domain',
      add: 'Add Domain',
      edit: 'Edit Domain',
      allAccounts: 'All Accounts',
      availableToClaim: 'Available to Claim',
      managedAccounts: 'Managed Accounts',
      verifyDomain: 'Verify Domain',
      claimAccounts: 'Claim Accounts',
      domainInvalid: 'Invalid format',
      noDomainsFound: 'No domains found',
      noDomainsAreAdded: 'No domains are added yet',
      verifySuccess: 'Domain verified successfully',
      verifyError:
        'Domain could not be verified. Make sure the domain is reachable and correctly set up.',
      errorSaving: 'Error saving domain',
      successClaimingAccounts: 'Accounts claimed successfully',
      errorClaimingAccounts: 'Error claiming accounts',
      deleteMsg: 'Are you sure you want to delete this domain?',
      nameHostAlias: 'Record Name',
      enterDomain: 'Enter domain',
      ttl: 'Time to live (TTL)',
      recordType: 'Record Type',
      recordOrData: 'Value',
      accountsToClaim: 'Accounts to claim',
      reviewAccounts: 'Review accounts',
      exportDescription:
        'Export an excel file to see {{count}} total account(s) that use an @{{domain}} email.',
      exportAccounts: 'Export Accounts',
      chooseAccounts: 'Choose accounts to claim',
      accountClaimTypes: {
        all_one: 'Claim 1 account',
        all_other: 'Claim all {{count}} accounts',
        specific: 'Claim specific accounts',
      },
      createTxtRecord: 'Create a new TXT record',
      createTxtRecordDescription:
        "Copy the information from all fields and add them to your domain host's DNS settings.",
      verifyTxtRecord: 'Verify the TXT record',
      verifyTxtRecordDescription: 'After you have added the TXT record, you can verify the domain.',
      verifyAlertTitle: 'Keep the DNS record on your server',
      verifyAlertDescription:
        "Remember to keep the DNS record on your server (don't delete it). We may need to verify it regularly.",
      settingsOf: 'Settings of {{domain}}',
      newUsers: 'New Users',
      autoClaimUsersTitle: 'Auto-claim new users',
      autoClaimUsersDescription:
        'Automatically add users signing up using this email domain to your team.',
      autoClaimToUnit: 'Add new users to the following unit:',
      deleteError: 'Error deleting domain',
      deleteSuccess: 'Domain deleted successfully',
      notifyOnAccountClaimTitle: 'Activate Change Request Process',
      notifyOnAccountClaimDescription:
        'Receive a notification for each automatically claimed user to verify their information.',
    },
    idp: {
      manageDomains: 'Manage E-Mail domains',
      active: 'Active',
      notActive: 'Not Active',
      setupScim: 'Setup SCIM',
      teaserDescription: 'Configure SSO and User Provisioning. Works with most Identity Providers.',
      identityProvider: 'Identity Provider',
      listPageTitle: 'Choose an Identity Provider',
      listPageDescription:
        'Integrate your Identity Provider to set up Single Sign-On and User Provisioning.',
      settingsPageDescription:
        'Manage the integration of your Identity Provider. Configure Single Sign-On and SCIM provisioning.',
      choose: 'Choose',
      addIdentityProviderDirectory: 'Add Identity Provider directory',
      directoryName: 'Directory name',
      createSuccess: 'Identity provider directory created successfully',
      createError: 'Error creating Identity Provider directory',
      updateSucess: 'Identity provider directory updated successfully',
      updateError: 'Error updating Identity Provider directory',
      settings: 'Settings',
      renameDirectory: 'Rename directory',
      dirName: 'Directory name',
      deleteConfiguration: 'Delete configuration',
      edit: 'Edit',
      try: 'Try',
      deleteSuccess: 'Identity provider directory disconnected successfully',
      deleteError: 'Error disconnecting Identity Provider directory',
      deleteMessage: 'Are you sure you want to disconnect this directory?',
      disconnect: {
        title: 'Before you disconnect',
        description: 'Before you can disconnect your Identity Provider, you need to:',
        bulletPoints: '• Delete SSO configuration\n• Delete user provisioning configuration',
        anchorText: 'Learn more about how to disconnect',
      },
      scim: {
        schemaRefresh: 'Refresh',
        openProfile: 'Open Profile',
        noSchemaFound:
          'This user was not provisioned via SCIM. There is therefore no schema available.',
        userSchemaAnalyzerInfo:
          'Here you can view and analyze the SCIM user schema of users provisioned via SCIM. These are the raw data sent from your Identity Provider to Lemontaps. Editing is not possible here.',
        openUserSchemaAnalyzer: 'User Schema Analyzer',
        openLtAttributesSidebar: 'Available Attributes',
        ltAttributesSidebarDescription:
          'Here you can find all attributes that you can insert into the SCIM mapping.',
        settings: 'Additional settings',
        editAttributeMapping: 'Edit mapping',
        attributeMappingTitle: 'Attribute Mapping',
        attributeMappingDescription:
          'Decide how incoming SCIM attributes (right) map onto Lemontaps attributes (left).',
        inviteUserUponProvisioning: 'Send invite when new user is provisioned',
        title: 'SCIM Provisioning',
        description:
          'Here you can set up and manage automatic user provisioning and deprovisioning via SCIM.',
        isActive:
          'SCIM is active. To manage provisioning settings, manage the SCIM configuration in your Identity Provider.',
        setupProvisioning: 'Start the setup',
        syncedUsers: 'Synced users',
        regenerateApiKey: 'Regenerate API key',
        deleteConfigurationConfirmation: 'Are you sure you want to delete this configuration?',
        deleteConfigurationSuccess: 'SCIM configuration deleted',
        deleteConfigurationError: 'Error deleting SCIM configuration',
        updateConfigurationError: 'Error updating SCIM configuration',
        stupScimProvisioning: 'SCIM setup',
        saveConfig: 'Save SCIM configuration',
        learnMoreAboutScim: 'Learn more about SCIM provisioning',
        regenerateKey: 'Regenerate key',
        updateSuccess: 'SCIM configuration updated successfully',
        updateError: 'Error updating SCIM configuration',
        applyMapping: 'Re-apply mapping',
        applyMappingInfo:
          'If you reapply the mapping, all profile attributes defined in the mapping above are rewritten according to their assignment. No values are emptied, only values are overwritten.',
        applyMappingConfirmationDescription:
          'The mapping will be re-applied which might lead to unwanted changes on your profiles. Do you want to continue?',
        applyMappingSuccess: 'Mapping applied successfully',
        reApplyMappingOnSave: 'Re-apply mapping on save',
        updateMappingError: {
          unrecognized_keys: 'Invalid Lemontaps attribute keys provided: {{keys}}',
          custom: 'Error updating attribute mapping',
          invalid_union: 'Values should be string or array of strings',
        },
        steps: {
          beforeYouBegin: {
            stepperTitle: 'Before you begin',
            title: 'Before you begin',
            description:
              'Before you set up user provisioning via SCIM, we recommend you: \nCreate test accounts and groups in your Identity Provider to prevent existing users from losing product access. When you connect your Identity Provider and sync for the first time, you can use these test accounts and groups to ensure everything works.',
            description2: 'After setup is complete, you will be able to:',
            description3:
              '• Manage user details from within your Identity Provider \n• Automatically provision new users \n• Automatically deprovision users',
          },
          setupScim: {
            stepperTitle: 'Setup SCIM',
            title: 'Details',
            description:
              'To set up user provisioning via SCIM and connect your Identity Provider with Lemontaps, copy the SCIM Base URL and the API Key into your Identity Provider. Enter "userName" as the unique identifier if asked for that value.',
            scimBaseUrl: 'SCIM base URL',
            apiKey: 'API key',
            apiKeyHelperText:
              "We don't save your API key. We recommend you store it somewhere safe.",
          },
          saveConfig: {
            stepperTitle: 'Save configuration',
            title: 'Save SCIM configuration',
            description:
              'You just finished setting up user provisioning via SCIM. Now, you can update synced groups and users to automatically access Atlassian products.',
          },
          regenerate: {
            stepperTitle: 'Regenerate Key',
            title: 'Regenarate directory API key',
            description:
              'Regenarate a new API key will disable the existing key. Update the credentials in your Identity Provider with the new details to continue syncing with your Identity Provider.',
          },
          apiKeys: {
            stepperTitle: 'API Keys',
          },
        },
      },
      sso: {
        selfServiceTicketPopup: {
          title: 'Self-Service Ticket URL',
          description:
            'Copy the following URL and provide it to your IT-department. With this URL, they will be able to set up or edit the SSO configuration.',
          inputLabel: 'Self-Service Ticket URL',
          buttonLabel: 'Generate Self-Service Ticket URL',
          buttonGenerateLabel: 'Generate Self-Service Ticket URL',
          error: 'Error fetching Self-Service Ticket URL',
        },
        successEnabled:
          'SSO is active. All users with the configured E-Mail domains must use SSO to log in.',
        renewSecret: 'Renew Secret',
        editDomains: 'Edit E-Mail domains',
        editConfiguration: 'Edit Configuration',
        test: 'Test',
        disable: 'Disable SSO',
        enable: 'Enable and Enforce SSO',
        warningNoDomainsConfigured:
          'SSO is enabled but is not currently used by any users, as no email domains have been added.',
        warningNotEnabled:
          'SSO has been configured but is not currently enabled. Only enable SSO if you have performed a successful test and added all email domains needed. Otherwise, you may lock yourself out of your account.',
        warningNotEnabled2:
          'After SSO has been enabled, all users with the configured email domains must use SSO to log in.',
        noDomainsAvailable:
          'At least one verified email domain must be set up to start the configuration.',
        selfServiceStarted: 'Finish the setup in the separate tab that has opened...',
        recover: {
          title: 'Recover SSO Access',
          description:
            'Enter your email address to receive instructions for recovering your SSO access. The email address must match the email address of an admin account.',
          emailLabel: 'Email Address',
          submit: 'Send Recovery Instructions',
        },
        testSuccess: 'SSO configuration successfully tested.',
        testError: 'Error testing SSO configuration. Check the settings.',
        testInProgress:
          'SSO setup is being tested in a separate tab. Waiting for the tab to be closed...',
        testCanceled: 'Test canceled.',
        testCancelButtonLabel: 'Cancel',
        testDialog: {
          title: 'Test SSO Setup',
          description: 'To test the SSO connection, follow these steps:',
          steps: `<0>Copy the following link:</0>
          <1></1>
          <0>Open an incognito window and open the link there.</0>
          <2>You should open the link in a different browser context, otherwise you will be logged out of your current session here.</2>
          <0>Authenticate there with the configured SSO strategy.</0>
          <0>You can debug there. When you have completed a successful authentication, you will see a success screen. Then you can close this dialog and enable SSO.</0>
          <2>Only enable SSO if you have performed a successful test. Otherwise, you may lock yourself out of your account.</2>`,
          copyValueLabel: 'SSO Test Link',
        },
        pasteJson: 'Paste JSON',
        enterUrl: 'Enter URL',
        enterDiscoveryUrlOrJson: 'Paste discovery URL or as JSON',
        discoveryUrl: 'Discovery URL',
        discoveryJson: 'Discovery JSON',
        notSupportedStrategyTitle: 'Not fully supported',
        notSupportedStrategyDescription:
          'Your current SSO connection strategy is not fully supported yet. If you want to make a change, please contact our support.',
        connectionEnabled: 'SSO enabled',
        cardTitle: 'Single Sign-On',
        cardDescription: 'Here you can set up and manage Single Sign-On (SSO).',
        buttonText: 'Start the setup',
        setupSaml: 'Set up Single Sign-On',
        pageTitle: 'SSO Configuration',
        entityId: 'Entity Id',
        singleSignOnUrlForCopy: 'Single Sign-On URL',
        signInUrl: 'Sign-in URL',
        signOutUrl: 'Sign-out URL',
        certificate: 'x509 Certificate',
        signInUrlHelper: 'signInUrlHelper',
        signOutUrlHelper: 'signOutUrlHelper',
        certificateHelper: 'certificateHelper',
        selectDomains: 'Select domains',
        oktaDomain: 'Okta Domain',
        oktaDomainHelper: 'oktaDomainHelper',
        clientID: 'Client ID',
        clientIDHelper: 'clientIDHelper',
        clientSecret: 'Client Secret',
        clientSecretHelper: 'clientSecretHelper',
        entraIdDomain: 'Entra ID Domain',
        entraIdDomainHelper: 'entraIdDomainHelper',
        metaDataUrl: 'Metadata URL',
        metaDataUrlHelper: 'metaDataUrlHelper',
        identityAPI: 'Identity API',
        azureActiveDirectoryV1: 'Azure Active Directory v1',
        microsoftIdentityPlatformV2: 'Microsoft Identity Platform v2',
        updateSuccess: 'SSO configuration updated successfully',
        updateError: 'Error updating SSO configuration',
        deleteSuccess: 'SSO configuration deleted successfully',
        deleteError: 'Error deleting SSO configuration',
        deleteConfigurationConfirmation: 'Are you sure you want to delete this configuration?',
        learnMoreAboutSaml: 'Learn more about Single Sign-On',
        learnMoreAboutDomains: 'Learn more about linking domains',
        copySection: {
          title: 'Copy URL to Identity Provider',
          description: 'Copy and paste these service provider URLS to your Identity Provider.',
        },
        editSection: {
          title: 'Edit SSO configuration',
          description: 'Copy these SSO details from your Identity Provider and paste them here.',
        },
        domainSection: {
          title: 'Domains',
          description: 'Select the E-Mail domains that should authenticate via SSO.',
        },
        steps: {
          beforeYouBegin: {
            stepperTitle: 'Before you begin',
            title: 'Before you begin',
            description: 'Please note the following:',
            description2:
              '• SSO allows your users to authenticate with company credentials on Lemontaps.\n• Make sure the IdP side is also correctly configured.',
            description3:
              'After the setup wizard, the SSO connection can be tested. Only thereafter SSO should be activated.',
            selectStrategy: 'Select strategy',
            setupDomainFirst: 'Set up a domain first',
          },
          copyUrls: {
            stepperTitle: 'Copy values',
            title: 'Copy values',
            description: 'What you need to configure SSO in your Identity Provider:',
            description2:
              '• Service provider entity URL\n• Service provider assertion consumer service URL\n• Public x509 certificate',
            description3: 'You can refer back to this page at any time.',
          },
          addSaml: {
            stepperTitle: 'Enter values',
            title: 'Enter values',
            description: 'Enter the required values here:',
            setupUsingMetadata: 'Simply enter the metadata URL of your Identity Provider',
            or: 'OR',
            setupManually: 'Enter manually',
          },
          linkDomain: {
            stepperTitle: 'Link domain',
            title: 'Link domain',
            description: 'Link at least one domain to this SSO configuration.',
            manageDomains: 'Manage domains',
          },
          save: {
            stepperTitle: 'Save and continue',
            title: 'Save configuration',
            description: 'You just finished setting up SSO. Now you can enforce SSO.',
          },
        },
      },
    },
    crmIntegration: {
      campaignConfigurator: {
        title: 'Assign campaigns',
        subheader: 'Should contacts be assigned a campaign when exporting to Salesforce?',
        selectCampaign: 'Select a campaign',
        assignment: {
          noAssignment: 'Do not assign to a campaign',
          letUserChoose: 'Let users select the campaign each time they export',
          autoAssign: 'Assign campaign',
        },
        success: 'Campaign assignment updated successfully',
        error: 'Error updating campaign assignment',
      },
      title: 'CRM Integration',
      description:
        'Connect Lemontaps to your CRM to auto or manual sync your Lemontaps contacts as CRM Contacts or Leads. Please read the help documentation to see which attributes will be pushed to your CRM.',
      settingsCard: {
        additionalSettings: 'Additional Settings',
        pushNonSupportedCustomFields: 'Custom Fields',
        shouldPushNonSupportedCustomFields: 'Add responses to notes',
        title: 'General CRM Integration Settings',
        autoSync:
          'Auto Export: Enable this workflow to automatically send new contacts to the CRM instantly upon creation.',
        manualSync:
          'Manual Push: Enable this workflow to choose manually which contacts to send to your CRM.',
        headerSyncType: 'Auto or Manual Export',
        headerUseLeads: 'Convert to Contacts or Leads',
        contacts: 'Contacts: Convert Lemontaps contacts into CRM Contacts',
        leads: 'Leads: Convert Lemontaps contacts into CRM Leads',
        notSpecified: 'Allow users to choose between "contact" or "lead".',
      },
      crmListCard: {
        title: 'Manage your CRM Integrations',
        subheader:
          'We support the following CRM systems. Click on a CRM system to start configuring it or to edit it.',
      },
      upgradeAlert: {
        title: 'Connect to your CRM account to sync Lemontaps contacts as CRM Leads.',
        description: 'Choose between an Auto Sync or Manual Push Option',
        learnMore: 'Learn more about the CRM integration',
      },
      exportStarted: 'Export to {{crm}} started on {{datetime}}',
      exportErrorDetails: 'Error details',
      exportFailedAuthorization:
        'Export to {{crm}} failed on {{datetime}} due to authorization error',
      exportedWithoutOwner: {
        lead: 'Exported to {{crm}} on {{datetime}} as a lead (without owner).',
        contact: 'Exported to {{crm}} on {{datetime}} as a contact (without owner).',
        notSpecified: 'Exported to {{crm}} on {{datetime}} (without owner).',
      },
      exportedWithOwner: {
        lead: 'Exported to {{crm}} on {{datetime}} as a lead (with owner).',
        contact: 'Exported to {{crm}} on {{datetime}} as a contact (with owner).',
        notSpecified: 'Exported to {{crm}} on {{datetime}} (with owner).',
      },
      exportFailed: {
        lead: 'Export to {{crm}} as a lead failed on {{datetime}}',
        contact: 'Export to {{crm}} as a contact failed on {{datetime}}',
        notSpecified: 'Export to {{crm}} failed on {{datetime}}',
      },
      exportFailedDuplicate: {
        lead: 'Export to {{crm}} as a lead failed on {{datetime}} due to duplicate entity',
        contact: 'Export to {{crm}} as a contact failed on {{datetime}} due to duplicate entity',
        notSpecified: 'Export to {{crm}} failed on {{datetime}} due to duplicate entity',
      },
      exportedOutlook:
        'Exported to {{crm}} on {{datetime}} (with owner). It may take up to several hours before the contact appears in Outlook',
      status: {
        notConnected: 'Not connected',
        added: 'Needs Configuration',
        authorized: 'Needs Configuration',
        invalid: 'Invalid Configuration',
        callable: 'Connected',
        disabled: 'Disabled',
      },
    },
    selectAllTexts: {
      profile: 'Select all {{count}} profiles?',
      lead: 'Select all {{count}} contacts?',
      unit: 'Select all {{count}} units?',
    },
    dropzone: {
      title: 'Click to upload or drag and drop',
      errors: {
        'file-invalid-type': 'Invalid file type. Accepted formats: {{formats}}',
        'file-too-large': 'File is too big (<{{maxSize}}MB for .{{ext}}).',
        'file-too-small': 'File is too small.',
        'too-many-files': 'Too many files uploaded.',
      },
    },
    filter: {
      title: 'Filters',
      addFilter: 'Add filter',
      searchLabel: 'Filter by...',
      operators: {
        is_in: 'is in',
        is_not_in: 'is not in',
        is_equal: 'is equal to',
        is_not_equal: 'is not equal to',
        is_like: 'includes',
        is_not_like: 'does not include',
        is_greater: 'is greater than',
        is_greater_or_equal: 'is greater or equal to',
        is_less: 'is less than',
        is_less_or_equal: 'is less or equal to',
        has_value: 'Is not empty',
        has_no_value: 'Is empty',
      },
      crmExportStatusOptions: {
        success: 'Success',
        error: 'Error',
        pending: 'Pending',
        errorDuplicate: 'Error (Duplicate)',
      },
    },
    ariaOpenSettings: 'Open profile settings',
    ariaPreviewProfile: 'Preview profile',
    ariaCopyProfileUrl: 'Copy profile URL',
    ariaDownloadProfileQrCodePNG: 'Download profile QR code PNG',
    ariaDownloadProfileQrCodeSVG: 'Download profile QR code SVG',
    ariaViewAllAnalytics: 'View all analytics',
    ariaviewAllLeads: 'View all leads',
    ariaSendInviteAfterUserCreate: 'Send invite after user creation',
    ariaSendInviteToSelected: 'Send invite to selected users',
    ariaBulkEditSelected: 'Bulk edit selected users',
    ariaExportSelected: 'Export selected',
    ariaUnitAssignSelected: 'Assign selected users to unit',
    ariaDeleteNfcCard: 'Delete {{name}} NFC card',
    ariaShareAnalytics: 'Share analytics',
    ariaOpenDateRangeSelector: 'Open date range selector. Current Selection: ',
    ariaCloseDrawer: 'Close drawer',
    ariaBulkOverride: 'Selected bulk option: Override',
    ariaBulkDelete: 'Selected bulk option: Delete',
    ariaShareQrInfo: 'Share QR instructions',
    ariaQrDownloadPNG: 'Download PNG {{type}} QR code',
    ariaQrDownloadSVG: 'Download SVG {{type}} QR code',
    ariaQrDownloadAppleWallet: 'Download Apple Wallet {{type}} QR code',
    ariaQrDownloadGoogleWallet: 'Download Google Wallet {{type}} QR code',
    ariaShareWhatsApp: 'Share via WhatsApp',
    ariaShareEmail: 'Share via Email',
    ariaShareLinkedIn: 'Share via LinkedIn',
    ariaWebShare: 'Share via Web Share API',
    ariaSaveContactColor: 'Save contact color - {{color}}',
    ariaFilesColor: 'Files color - {{color}}',
    ariaGenericWebsiteLinkColor: 'Generic website link color - {{color}}',
    ariaCoverImageSettings: 'Open cover image settings',
    ariaProfileImageSettings: 'Open profile image settings',
    ariaLogoImageSettings: 'Open logo settings',
    ariaFaviconImageSettings: 'Open favicon settings',
    ariaDelete: 'Delete {{name}}',
    ariaEdit: 'Edit {{name}}',
    ariaAddLinkTemplate: 'Add link template',
    ariaAddAddressTemplate: 'Add address template',
    ariaAddBioContent: 'Add default profile attribute',
    ariaAddFileTemplate: 'Add file template',
    ariaClear: 'Clear',
    ariaSelect: 'Select {{name}}',
    ariaUnitViewMembers: 'View members of unit {{name}}',
    ariaDomainsVerify: 'Verify domain {{name}}',
    ariaDomainsClaimAccounts: 'Claim accounts of domain {{name}}',
    ariaSettings: '{{name}} - reveal more options',
    ariaProfileStatusActions: 'View status actions of {{name}}',
    ariaEditUser: '{{name}} - edit',
    ariaEditContact: '{{name}} - edit',
    ariaBusinessCardImageSettings: 'Open business card image settings',
    ariaCloseScanner: 'Close business card scanner',
    ariaGoBackToPreviewsScreen: 'Go back to previews screen',
    ariaBusinessCardImagesToggler: 'Toggle business card images visibility',
    ariaRefreshCampaigns: 'Refresh campaigns',
    ariaSaveCrmConfiguration: 'Save CRM configuration',
    ariaOpenIdpSettings: 'Open Identity Provider settings',
    ariaOpenScimSettings: 'Open SCIM settings',
    ariaOpenSsoSettings: 'Open SSO settings',
    ariaClickToCopy: 'Click to copy',
    ariaRedirectBusinesssCardTo: 'Redirect business card to {{link}}',
    ariaRefreshCrmConfigurations: 'Refresh CRM configurations',
    ariaToggleVCardFieldVisibility: 'Toggle "{{field}}" field visibility',
    ariaHideLinkFromProfile: '{{link}} - hide on business card',
    ariaEditMessage: '{{name}} - Edit',
    ariaDeleteMessage: '{{name}} - Delete',
    ariaHideMessage: '{{name}} - Hide on business card',
    ariaShowMessage: '{{name}} - Show on business card (currently not shown)',
    ariaRedirectMessage: '{{name}} - Redirect business card to this link.',
    ariaRedirectOffMessage: '{{name}} - Deactivate redirect behavior.',
    ariaDisabledFieldHelpButton: '{{fieldName}} - Help',
    ariaLeadsTableCaption: 'Leads table, column headers with buttons are sortable',
    ariaUnitsTableCaption: 'Units table, column headers with buttons are sortable',
    ariaDomainsTableCaption: 'Domains table',
    ariaProfilesTableCaption: 'Profiles table, column headers with buttons are sortable',
    ariaThemeLinkFileEdit: '{{name}} (globally defined by an admin) - Edit',
    showNextPage: 'Show next page',
    showPreviousPage: 'Show previous page',
    ariaShowColumn: '{{name}} - Show column',
    ariaToggleVisibilityElement: '{{name}} - Visible',
    ariaOpenActionFor: 'Open actions for {{name}}',
    ariaToggleBioAttributeVisibility: 'Toggle "{{name}}" field visibility',
    ariaDnd: {
      draggableItem: 'Draggable item',
      draggableDescription:
        'Press space bar to start a drag. When dragging you can use the arrow keys to move the item around and escape to cancel. Some screen readers may require you to be in focus mode or to use your pass through key.',
      onDragStart:
        'You have lifted the item "{{itemName}}" in position {{position}}. Use the arrow keys to move it.',
      onDragUpdate:
        'You have moved the item from position {{fromPosition}} to {{toPosition}}. Press the spacebar to drop it.',
      onDragEnd:
        'You have dropped the item {{itemName}}. You have moved the item from position {{fromPosition}} to {{toPosition}}.',
    },
    ariaLeadCustomFieldOption: 'Lead custom field option',
    'contactDetailsBox.boxLabel': 'My Contact Details',
    'urlsBox_files.boxLabel': 'My Files',
    'urlsBox_links.boxLabel': 'My Links',
    'contactFormBox.boxLabel': 'Contact form',
    'customBioTextBox.boxLabel': 'About me',
    'teamDirectoryBox.boxLabel': 'Team Directory',
    boxOrder: 'Box Order',
    loginError: 'Could not log you in',
    loginErrorInfo:
      'Try to log out and then login again. If the problem persists, contact your internal contact person or us via the form above.',
    sent: 'Sent',
    sendMail: 'Send Mail',
    teamDirectory: 'Team Directory',
    showTeamDirectoryBoxDescription:
      'Enable to display a box showing all team profiles. If assigned to a unit, only main unit users appear in the box.',
    teamDirectoryGloballyActive:
      "The team directory is already visible due to this profile's profile design Settings.",
    teamDirectoryShowAll: 'Show all team members.',
    autoVCardDownloadGloballyActive:
      'This setting is globally enabled via the profile design settings and can only be changed by an admin.',
    crmCustomFieldsImported: 'CRM custom fields imported successfully',
    importCrmCustomFields: 'Re-Import CRM Fields',
    voiceNote: {
      transcriptionDisabled: 'Transcription is not available. Upgrade to get access.',
      failedToTranscribe: 'Failed to transcribe voice note',
      deleteSuccess: 'Voice note deleted successfully',
      deleteError: 'Error deleting voice note',
      addSuccess: 'Voice note added successfully',
      addError: 'Error adding voice note',
      deleteConfirmation: 'Are you sure you want to delete this voice note?',
      maxLimitReached: 'You have reached the maximum limit of voice notes',
      recordingNotAllowedLeadMustBeCreatedFirst:
        'Recording is not allowed. Please create a lead first.',
      updateSuccess: 'Voice note updated successfully',
      updateError: 'Error updating voice note',
      transcript: 'Transcript',
      reTranscribe: 'Re-transcribe',
      copy: 'Copy',
      edit: 'Edit',
      copyToNotesField: 'Copy To Notes Field',
      copySuccess: 'Text copied to clipboard',
      copyToNotesFieldSuccess: 'Text copied to notes field successfully',
      showTranscript: 'Show transcript',
      viewEdit: 'View/Edit',
      transcriptionLoading: 'Transcribing voice note...',
      quotaExceeded: 'Not enough credits for making AI actions',
    },
    ariaVoiceNoteSettings: 'Open voice note settings',
    ariaVoiceNoteAiActions: 'Open voice note AI actions',
    billingPage: {
      title: 'Billing',
      alertTitle: 'Important Information',
      alertDescription:
        'Only users whose email is registered as the billing contact can view this information. If you cannot view the information, please contact support@lemontaps.com.',
      licenseCard: {
        yourSubscription: 'Your Subscription',
        licenses: '{{count}} License Seats',
        licensesInUse: 'Currently {{count}} seats in use',
        licenseDescription: 'You can find the contract duration in your previous invoices.',
        showSubscriptionDetails: 'View Subscription Details',
        unlimitedLicenses: 'Unlimited License Seats',
      },
      showInvoices: 'View Invoices',
      changeBillingAddress: 'Change Billing Address',
      changePaymentMethod: 'Change Payment Method',
      changePlan: 'Change Plan or Add Add-on?',
      changePlanDescription: 'We can help you find the right subscription for you.',
      changePlanButton: 'Talk to Sales',
      showSubscription: 'Cancel Subscription',
      subscriptionDialogTitle: 'Cancel Subscription',
      subscriptionDialogContent:
        'Please send your cancellation to support@lemontaps.com. Cancellation must be submitted at least two months before the end of the contract year, otherwise, the subscription will automatically renew for another year. \nDetails about the current service period can be found in your last invoice here.',
      limitAccededDialogTitle: 'License Limit Exceeded',
      limitAccededDialogContent:
        'You have exceeded your license limit – no problem! The additional licenses will be automatically recorded, and you will receive an invoice for them once a month. These licenses will be prorated to the annual fee for the remaining months.',
      popupClose: 'Close',
    },
    ariaEmailTemplateSettings: 'Open email template settings',
    ariaUnitSettings: 'Open unit settings',
    ariaEditBioAttribute: 'Edit "{{name}}" field',
    ariaFaviconImageDelete: 'Delete favicon',
    ariaDeleteBioAttribute: 'Delete "{{name}}" field',
  },
};
